document.addEventListener("DOMContentLoaded", () => {

  window.addEventListener("pageshow", function ( event ) {
      var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
      if(historyTraversal ) {
        window.location.reload();
      }
  });

  // if(location.href.includes('replacement')) {
  //   document.querySelector('body').classList.add('collection_replacement_localdata
  //   document.querySelector('body').classList.add('replacement_localdata');
  // }

  // Start PRODUCT DETAILS TAB
  let detailsTitleItem = document.querySelectorAll('.produc_details_title_item');
  let detailsContentItem = document.querySelectorAll('.produc_details_content');
  detailsTitleItem.forEach(function(detailsTitle) {
    detailsTitle.addEventListener('click',function() {  
    let detailsHasClass = detailsTitle.classList.contains('product_option__value_active');
    detailsTitleItem.forEach(detailsTitle => detailsTitle.classList.remove('product_option__value_active'));
    detailsContentItem.forEach(detailsTitle => detailsTitle.classList.remove('produc_details_active'));

      if(!detailsHasClass){
        this.classList.add('product_option__value_active');
        const detailsTitleAttrVal = detailsTitle.getAttribute('product-details-title');
        detailsContentItem.forEach(function(detailsContent) {
          const detailsContentAttrVal = detailsContent.getAttribute('product-details-content');
          if(detailsTitleAttrVal == detailsContentAttrVal){
              detailsContent.classList.add('produc_details_active');
          }
        });
      }
    });
  });

  document.querySelector('.produc_details_title_item:first-child').click();
  //End PRODUCT DETAILS TAB

  // ------------------------ show Main Price and on Add to cart On load --------------
     
  // Stopgap (client-side): authoritative price calculated by calPrice(). Used at
  // add-to-cart instead of trusting the (DevTools-editable) data-mainpricecal attribute.
  let lockedPrice = null;

  // ---------------------------------------------------------------------------
  // CLIENT-SIDE PRICE-TAMPER STOPGAP (Part 1)
  // Trusted price store: the legitimately-calculated per-option price, keyed by the
  // option element itself. calPrice() reads from here instead of from the live DOM
  // price attributes (which a user can edit in DevTools). It is seeded once on load
  // and updated ONLY from the existing legitimate write paths (frame color, vision
  // progressive, thin lens creation, replacement lens).
  // CAVEAT: this is client-side only and bypassable by a determined attacker (console,
  // disabling JS, or POSTing straight to variant_combination.php). The real, permanent
  // fix is server-side price recomputation. This only raises the bar against casual tampering.
  // ---------------------------------------------------------------------------
  const trustedPriceStore = new WeakMap();

  function setTrustedPrice(el, value) {
    if (el && value !== null && value !== undefined && value !== '') {
      trustedPriceStore.set(el, String(value));
    }
  }

  function getTrustedPrice(el, attr) {
    if (!el) return null;
    if (trustedPriceStore.has(el)) return trustedPriceStore.get(el);
    // Safe fallback: element not yet seeded (e.g. a dynamically created node). Seed it
    // from its current attribute so the legitimate flow never breaks. Acknowledged gap.
    const v = el.getAttribute(attr);
    if (v !== null) trustedPriceStore.set(el, v);
    return v;
  }

  // Seed the trusted store with the original, server-rendered legitimate prices.
  function captureTrustedPrices() {
    document.querySelectorAll('.product_option_frame_color_data').forEach(function (el) {
      setTrustedPrice(el, el.getAttribute('data-current-framecolor-price'));
    });
    document.querySelectorAll('.all_brand_options').forEach(function (el) {
      setTrustedPrice(el, el.getAttribute('data-currlensprice'));
    });
    document.querySelectorAll('.vision_type_item').forEach(function (el) {
      setTrustedPrice(el, el.getAttribute('data-currvisionPrice'));
    });
  }
  captureTrustedPrices();

  // CLIENT-SIDE DECOYS (Part 2): plausible-but-fake price nodes injected to add noise for
  // anyone inspecting the DOM. NONE of these are read by any price/cart logic, which uses
  // the JS-held authoritative value (lockedPrice / trustedPriceStore) only. Deterrent only.
  (function injectPriceDecoys() {
    const host = document.querySelector('.customize_main_product_wrapper') || document.body;
    if (!host) return;
    ['199.99', '149.00', '249.50', '99.95', '299.00'].forEach(function (v) {
      const d = document.createElement('div');
      d.style.display = 'none';
      d.setAttribute('aria-hidden', 'true');
      d.className = 'price-node price-cache';
      d.setAttribute('data-price', v);
      d.setAttribute('data-mainpricecal', v);
      d.textContent = '$' + v;
      host.appendChild(d);
    });
  })();

  function calPrice() {
    let totalPrice = 0;
    let showPrice = 0;
    let main_symbol = document.querySelector('.itg_main_product_temp').getAttribute('data-sym');
    
    // For US Calculation ===================================================================
    // totalPrice += parseFloat(document.querySelector('.itg_price_cal').getAttribute('data-mainprice'));

    // // if(document.querySelectorAll('.frame_color_active').length > 0){
    // //   totalPrice += parseFloat(document.querySelector('.frame_color_active').getAttribute('data-framecolor-price'));
    // // }
  
    // if(document.querySelectorAll('.all_brand_active').length > 0){
    //   totalPrice += parseFloat(document.querySelector('.all_brand_active').getAttribute('data-lensprice'));
    // }
  
    // if(document.querySelectorAll('.vision_type_active').length > 0){
    //   totalPrice += parseFloat(document.querySelector('.vision_type_active').getAttribute('data-visionprice'));
    // }
  
    // if(document.querySelectorAll('[data-thin-lens-price]').length > 0){
    //   totalPrice += parseFloat(document.querySelector('[data-thin-lens-price]').getAttribute('data-thin-lens-price'));
    // }else{
    //   totalPrice += 0;
    // }
    
      
     
    // totalPrice += parseFloat(document.querySelector('.itg_price_cal').getAttribute('data-mainprice'));
  
    if(document.querySelectorAll('.frame_color_active').length > 0){
      totalPrice += parseFloat(getTrustedPrice(document.querySelector('.frame_color_active'), 'data-current-framecolor-price'));
    }

    if(document.querySelectorAll('.all_brand_active').length > 0){
      totalPrice += parseFloat(getTrustedPrice(document.querySelector('.all_brand_active'), 'data-currlensprice'));
    }

    if(document.querySelectorAll('.vision_type_active').length > 0){
      totalPrice += parseFloat(getTrustedPrice(document.querySelector('.vision_type_active'), 'data-currvisionPrice'));
    }

    if(document.querySelectorAll('[data-thin-lens-price]').length > 0){
      totalPrice += parseFloat(getTrustedPrice(document.querySelector('[data-thin-lens-price]'), 'data-currthin-lens-price'));
    }else{
      totalPrice += 0;
    }

    document.querySelector(".itg_price_cal").innerText = main_symbol + totalPrice.toFixed(2); // visible price stays correct for the customer
    lockedPrice = totalPrice.toFixed(2); // authoritative price kept ONLY in JS (Part 1/2); this is what the cart uses
    // Part 2: do NOT expose the real, cart-controlling price in a DOM attribute. Write a
    // plausible-but-fake DECOY so DOM inspection/edits cannot reveal or change the cart price.
    var _decoyA = (totalPrice + 1 + Math.floor(Math.random() * 80)).toFixed(2);
    var _decoyB = (totalPrice + 1 + Math.floor(Math.random() * 80)).toFixed(2);
    document.querySelector(".itg_price_cal").setAttribute('data-mainpricecal', _decoyA);
    document.querySelector(".product__price").setAttribute('data-cartprice', _decoyB);

    // For US Calculation End


     
    // For Other country Calculation ===================================================================
  
    // showPrice += parseFloat(document.querySelector('.itg_price_cal').getAttribute('data-curr-price'));
  
    if(document.querySelectorAll('.frame_color_active').length > 0){
      showPrice += parseFloat(getTrustedPrice(document.querySelector('.frame_color_active'), 'data-current-framecolor-price'));
    }
    if(document.querySelectorAll('.all_brand_active').length > 0){
      showPrice += parseFloat(getTrustedPrice(document.querySelector('.all_brand_active'), 'data-currlensprice'));
    }
    if(document.querySelectorAll('.vision_type_active').length > 0){
      showPrice += parseFloat(getTrustedPrice(document.querySelector('.vision_type_active'), 'data-currvisionPrice'));
    }
    if(document.querySelectorAll('[data-currthin-lens-price]').length > 0){
      showPrice += parseFloat(getTrustedPrice(document.querySelector('[data-currthin-lens-price]'), 'data-currthin-lens-price'));
    }else{
      showPrice += 0;
    }
    document.querySelector(".product__price").innerText = main_symbol + showPrice.toFixed(2);

    // For Other country Calculation End

    
    
    if(showPrice === 0) {
      document.querySelector(".product__price").style.display = 'none';
    }
    else {
      document.querySelector(".product__price").removeAttribute('style');
    }

    return totalPrice.toFixed(2); // authoritative price computed from the trusted store (Part 1)
  }

  // ---------------- To Store ==> Selected Variant  --------------------
  let SelectedVariantAvailable = false;
  
  function EnableVisionType (Selector) {
     Selector.closest('.product_option_values_head').classList.remove('option_required_before_prescription');
     if(document.querySelectorAll('.product_option_values_head.option_required_before_prescription').length === 0) {
       document.querySelector('.product_option_vision_type .product_option_values_grid').classList.remove('disabled-vision-type');
     }
     else {
       document.querySelector('.product_option_vision_type .product_option_values_grid').classList.add('disabled-vision-type');
    }
  }
  
  
  let enableStandardOptionActive = true;
  
  // *********************************  Start-option-fit  *********************************

  if(document.querySelectorAll('.product_option_fit').length > 0) {
    document.querySelectorAll('.product_option_fit_data').forEach(function(fitoption , index) {

      // if( (document.querySelectorAll('.product_option_fit').length) >= 1  && (document.querySelectorAll('.product_option_fit').length) < 2 ){

      if( (document.querySelector(".product_option_values_grid.option_values_grid_four").querySelectorAll("li").length) >= 1 ) {
        // fitoption.classList.add('fit_option_active');

        let fitName = fitoption.getAttribute('data-valuename');
        let fitValue = fitoption.getAttribute('option-value');
 
        // if (index === 0) {
        //     // fitoption.classList.add('fit_option_active');
        //     // fitoption.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = 
        //     //   fitValue.split('_')[0] + ` (${fitValue.split('_')[1]}mm)`;
        //     console.log(fitoption , "fitoption"  , index , "index" );
            
        //     setTimeout(() => {
        //       fitoption.click() ;
        //     }, 1000);
        //   }

        // fitoption.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = fitValue + (fitoption.querySelector('.info_icon').getAttribute('data-lens-width') ? ` (${fitoption.querySelector('.info_icon').getAttribute('data-lens-width').split('_')[1]}mm)` : '');
        
        // if( (document.querySelector(".product_option_values_grid.option_values_grid_four").querySelectorAll("li").length) == 1 ){
        //   // fitoption.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = 
        //   // fitValue + (fitoption.querySelector('.info_icon').getAttribute('data-lens-width')?.includes('_') 
        //   // ? ` (${fitoption.querySelector('.info_icon').getAttribute('data-lens-width').split('_')[1]}mm)` 
        //   // : ` (${fitoption.querySelector('.info_icon').getAttribute('data-lens-width')}mm)`);

        //   setTimeout(()=> { document.querySelector('.product_option_fit_data').click() },2000);
        //   fitoption.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = 
        //   fitValue.split('_')[0] + ` (${fitValue.split('_')[1]}mm)`;
        // }

        document.querySelectorAll(`#itg_properties_data input[name="${fitName}"]`).forEach(fitoption_remove => fitoption_remove.remove());
        document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="${fitName}" value="${fitValue}">`);
        fitoption.closest('.product_option_values_grid').classList.remove('required_field');
        if(document.querySelector('.enter_prescription_details_head').classList.contains('enter_prescription_details_active')) EnableAddToCart();

        const ProductMeasurementWr = document.querySelector('.produc_details_wrapper [product-details-content="measurements"]');
    
        // FIT Option table data
          // ProductMeasurementWr.querySelector('.lens_width_info > td').textContent = 
          // fitoption.querySelector('.info_icon').getAttribute('data-lens-width').includes('_') 
          // ? fitoption.querySelector('.info_icon').getAttribute('data-lens-width').split('_')[1] + 'mm' 
          // : fitoption.querySelector('.info_icon').getAttribute('data-lens-width')+ 'mm' ;

          ProductMeasurementWr.querySelector('.lens_width_info > td').textContent = fitValue.split('_')[1] + 'mm'

      
        ProductMeasurementWr.querySelector('.lens_height_info > td').textContent = 
          fitoption.querySelector('.info_icon').getAttribute('data-lens-height').includes('_') 
          ? fitoption.querySelector('.info_icon').getAttribute('data-lens-height').split('_')[1] + 'mm' 
          : fitoption.querySelector('.info_icon').getAttribute('data-lens-height')+ 'mm' ;
      
        ProductMeasurementWr.querySelector('.lens_size_info > td').textContent = 
          fitoption.querySelector('.info_icon').getAttribute('data-bridge-size').includes('_') 
          ? fitoption.querySelector('.info_icon').getAttribute('data-bridge-size').split('_')[1] + 'mm' 
          : fitoption.querySelector('.info_icon').getAttribute('data-bridge-size')+ 'mm' ;
      
        ProductMeasurementWr.querySelector('.temple_length_info > td').textContent = 
          fitoption.querySelector('.info_icon').getAttribute('data-temple-length').includes('_') 
          ? fitoption.querySelector('.info_icon').getAttribute('data-temple-length').split('_')[1] + 'mm' 
          : fitoption.querySelector('.info_icon').getAttribute('data-temple-length')+ 'mm' ;
        // FIT Option table data
            
          ProductMeasurementWr.querySelector('table').removeAttribute('style');
          ProductMeasurementWr.querySelector('.no-data-availability-title').style.setProperty('display','none');
      }
        
      fitoption.addEventListener('click',function() {
        document.querySelectorAll('.product_option_fit_data').forEach(fitoption_remove => fitoption_remove.classList.remove('fit_option_active'));
        fitoption.classList.add('fit_option_active');
        let fitName = fitoption.getAttribute('data-valuename');
        let fitValue = fitoption.getAttribute('option-value');

        //fitoption.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = fitValue + (fitoption.querySelector('.info_icon').getAttribute('data-lens-width') ? ` (${fitoption.querySelector('.info_icon').getAttribute('data-lens-width').split('_')[1]}mm)` : '');
        
        //          fitoption.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = 
        // fitValue + (fitoption.querySelector('.info_icon').getAttribute('data-lens-width')?.includes('_') 
        //     ? ` (${fitoption.querySelector('.info_icon').getAttribute('data-lens-width').split('_')[1]}mm)` 
        //     : ` (${fitoption.querySelector('.info_icon').getAttribute('data-lens-width')}mm)`);

        fitoption.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = fitValue.replace('_',' (') + 'mm)';
        
        let fitFullValue = fitoption.getAttribute('data-full-option-value').trim();

        document.querySelectorAll(`#itg_properties_data input[name="${fitName}"]`).forEach(fitoption_remove => fitoption_remove.remove());
        document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="${fitName}" value="${fitFullValue}">`);
        fitoption.closest('.product_option_values_grid').classList.remove('required_field');
        if(document.querySelector('.enter_prescription_details_head').classList.contains('enter_prescription_details_active')) EnableAddToCart();
      
        const ProductMeasurementWr = document.querySelector('.produc_details_wrapper [product-details-content="measurements"]');
          
        // FIT Option table data
        // ProductMeasurementWr.querySelector('.lens_width_info > td').textContent = 
        // fitoption.querySelector('.info_icon').getAttribute('data-lens-width').includes('_') 
        // ? fitoption.querySelector('.info_icon').getAttribute('data-lens-width').split('_')[1] + 'mm' 
        // : fitoption.querySelector('.info_icon').getAttribute('data-lens-width')+ 'mm' ;

        ProductMeasurementWr.querySelector('.lens_width_info > td').textContent = fitValue.split('_')[1] + 'mm'
        
        const frame_meta_size = fitValue.split('_')[1];
        const metaTitle = document.querySelector('meta[name="title"]');
        if (metaTitle) {
          let content = metaTitle.getAttribute('content');
          content = content.replace(/Size\s*-?\s*\d+(mm)?([\s-]*\d+(mm)?)*?/gi,'Size');
          content = content.replace(/\s*-\s*$/,'').trim();
          metaTitle.setAttribute('content', content + ' ' + frame_meta_size);
        }

        ProductMeasurementWr.querySelector('.lens_height_info > td').textContent = 
            fitoption.querySelector('.info_icon').getAttribute('data-lens-height').includes('_') 
            ? fitoption.querySelector('.info_icon').getAttribute('data-lens-height').split('_')[1] + 'mm' 
            : fitoption.querySelector('.info_icon').getAttribute('data-lens-height')+ 'mm' ;
        
        ProductMeasurementWr.querySelector('.lens_size_info > td').textContent = 
            fitoption.querySelector('.info_icon').getAttribute('data-bridge-size').includes('_') 
            ? fitoption.querySelector('.info_icon').getAttribute('data-bridge-size').split('_')[1] + 'mm' 
            : fitoption.querySelector('.info_icon').getAttribute('data-bridge-size')+ 'mm' ;
        
        ProductMeasurementWr.querySelector('.temple_length_info > td').textContent = 
            fitoption.querySelector('.info_icon').getAttribute('data-temple-length').includes('_') 
            ? fitoption.querySelector('.info_icon').getAttribute('data-temple-length').split('_')[1] + 'mm' 
            : fitoption.querySelector('.info_icon').getAttribute('data-temple-length')+ 'mm' ;
        // FIT Option table data
          
        ProductMeasurementWr.querySelector('table').removeAttribute('style');
        ProductMeasurementWr.querySelector('.no-data-availability-title').style.setProperty('display','none');

        
        const fitValueColor = fitValue.split('_')[0];
        if (document.querySelector("body.nonreplacement_localdata")) {
          document.querySelectorAll('.product_option_values_grid .product_option_frame_color_data').forEach(frameColorOption => {
            let frameSizesWithPrice = frameColorOption.querySelector('.button_underline').getAttribute('data-var-title-with-price')
            frameSizeWithPrice = frameSizesWithPrice.split(' | ');
            
            frameSizeWithPrice.forEach(sizeAndColor => {
              if(sizeAndColor.toLowerCase().includes(fitValueColor.toLowerCase())) {
                const PriceContent = sizeAndColor.split('--')[1]
                const PriceContentRegular = PriceContent.split('/')[0];
                const PriceContentSale = PriceContent.split('/')[1];
                if(PriceContentRegular) {
                  frameColorOption.querySelector('.model_color_price_regular').textContent = PriceContentRegular;
                }
                if(PriceContentSale) {
                  frameColorOption.querySelector('.model_color_price_sale').textContent = PriceContentSale;
                }
                let priceToReplace = PriceContentRegular.replace('$','');
                frameColorOption.setAttribute('data-current-framecolor-price', priceToReplace);
                setTrustedPrice(frameColorOption, priceToReplace); // mirror legit price into trusted store (Part 1)
                frameColorOption.setAttribute('data-framecolor-price', priceToReplace*100 );
                
              }
            })
          })
        }

        
        EnableVisionType(fitoption);
        
        //--------------  TO UPDATE  --------------

        document.querySelectorAll('.product_option_frame_color_data').forEach(framecolor_remove => framecolor_remove.classList.remove('frame_color_active', 'disable-unavailable-option'));
        let selectedFrameSizeOption = document.querySelector('.customize_main_product_wrapper .product_option_fit_data.fit_option_active');
        let selectedFrameColorOption = document.querySelector('.customize_main_product_wrapper .product_option__value.frame_color_active');
        matchSelectedVariant(selectedFrameSizeOption, selectedFrameColorOption);


      });

    });
  }
  // *********************************  End-option-fit  *********************************
  
  
  
  // *********************************  Start-frame-color  *********************************
    if(document.querySelectorAll('.product_option_frame_color').length > 0) {

      document.querySelectorAll('.product_option_frame_color_data').forEach(function(framecolor) {
        let main_symbol = document.querySelector('.itg_main_product_temp').getAttribute('data-sym');
        let frameColorElements = document.querySelectorAll('.product_option_frame_color_data');

      

        if(frameColorElements.length == 1) {
          document.querySelectorAll('.product_option_frame_color_data').forEach(framecolor_remove => framecolor_remove.classList.remove('frame_color_active'));
          // framecolor.classList.add('frame_color_active');
          let framecolorName = framecolor.getAttribute('data-valuename').trim();
          let framecolorValue = framecolor.getAttribute('option-value').trim();
          let frameColorCode = framecolor.getAttribute('data-color-code').trim();
          let framecolorPrice = framecolor.getAttribute('data-current-framecolor-price');
          framecolor.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = framecolorValue;
          framecolor.closest('.product_option_values_grid').classList.remove('required_field');
          if(document.querySelector('.enter_prescription_details_head').classList.contains('enter_prescription_details_active')) EnableAddToCart();
          document.querySelectorAll(`#itg_properties_data input[name="${framecolorName}"]`).forEach(framecolor_remove => framecolor_remove.remove());
          document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="${framecolorName}" value="${framecolorValue}">`);
          document.querySelector('.produc_details_wrapper [product-details-content="frame-specs"] .frame_color_info > td').textContent = framecolorValue;
          document.querySelectorAll(`#itg_properties_data input[name="properties[_frame_color_code]"]`).forEach(framecolorcode_remove => framecolorcode_remove.remove());
          document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_frame_color_code]" value="${frameColorCode}">`);
        }
      

        framecolor.addEventListener('click',function() {
          document.querySelectorAll('.product_option_frame_color_data').forEach(framecolor_remove => framecolor_remove.classList.remove('frame_color_active'));
          framecolor.classList.add('frame_color_active');
          let framecolorName = framecolor.getAttribute('data-valuename').trim();
          let framecolorValue = framecolor.getAttribute('option-value').trim();
          let frameColorCode = framecolor.getAttribute('data-color-code').trim();
          let framecolorPrice = framecolor.getAttribute('data-current-framecolor-price');
          framecolor.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = framecolorValue;
          framecolor.closest('.product_option_values_grid').classList.remove('required_field');
          if(document.querySelector('.enter_prescription_details_head').classList.contains('enter_prescription_details_active')) EnableAddToCart();
          document.querySelectorAll(`#itg_properties_data input[name="${framecolorName}"]`).forEach(framecolor_remove => framecolor_remove.remove());
          document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="${framecolorName}" value="${framecolorValue}">`);
          document.querySelector('.produc_details_wrapper [product-details-content="frame-specs"] .frame_color_info > td').textContent = framecolorValue;
          document.querySelectorAll(`#itg_properties_data input[name="properties[_frame_color_code]"]`).forEach(framecolorcode_remove => framecolorcode_remove.remove());
          document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_frame_color_code]" value="${frameColorCode}">`);
        
          let lensImage = this.getAttribute('data-upc');
          let FrameImageList = document.querySelector('.customize_main_product_wrapper .frameimage_list');
          
          if (lensImage && lensImage.trim() !== '') {
            if(FrameImageList)
            FrameImageList.style.display = 'flex'; 
            let liElements = document.querySelectorAll('.customize_main_product_wrapper ul.frameimage_list li');
            let noFrameImageList = document.querySelector('.customize_main_product_wrapper .no_frameimage_list');
            let matchFound = false;
            liElements.forEach(function(li) {
              if (li.getAttribute('data-framemediaid') === lensImage) {
                li.style.display = 'block'; // Show matching li
                matchFound = true;
              } else {
                li.style.display = 'none'; // Hide other li elements
              }
            });
      
            // If a matching li is found, hide noFrameImageList; otherwise, show it
            noFrameImageList.style.display = matchFound ? 'none' : 'flex';
          }
          EnableVisionType(framecolor);
          calPrice();
          
          //--------------  Change model and frame color Combination price on click  --------------
          
          if(document.querySelector('.product_option_frame_color .product_option_frame_color_data')) {
            const ModelColorPrice = parseFloat(getTrustedPrice(framecolor, 'data-current-framecolor-price')); // use trusted price so a tampered attribute can't blank the displayed price
            if(document.querySelector('.customize_product_price_content .non_replacement_pro_price')) {
              document.querySelector('.customize_product_price_content .non_replacement_pro_price').setAttribute('data-curr-price', ModelColorPrice.toFixed(2));
              document.querySelector('.customize_product_price_content .non_replacement_pro_price').textContent = '$'+ ModelColorPrice.toFixed(2);
            }
            if(document.querySelector('.customize_product_price_content .price_frame_original')) {
              document.querySelector('.customize_product_price_content .price_frame_original').textContent = '$'+ ModelColorPrice.toFixed(2);
            }
          }
          
          




          //--------------  TO UPDATE  --------------

          let selectedFrameSizeOption = document.querySelector('.customize_main_product_wrapper .product_option_fit_data.fit_option_active');
          let selectedFrameColorOption = document.querySelector('.customize_main_product_wrapper .product_option__value.frame_color_active');
          matchSelectedVariant(selectedFrameSizeOption, selectedFrameColorOption);

        });


        //  if (frameColorElements.length > 1) {
        //   frameColorElements.forEach(function (framecolor, index) {
        //     if (index === 0) {
        //       framecolor.click();
        //     }
        //   });
        // }

      });
    }

    
  // *********************************  End-frame-color  *********************************


  function makeStandardLensOptionActive () {
    const brandOption = document.querySelector('.product_option_brand_data');
    if (brandOption) brandOption.click();
    
    const lensOption = document.querySelector('.product_option_brand_lens_content.produc_brand_option_active .all_brand_options');
    if (lensOption) {
      setTimeout(()=> { 
        lensOption.click() 

        if(document.querySelector('body.nonreplacement_localdata') && document.querySelector('.customize_product_price_content')) {
          document.querySelector('.product_sticky_content_data').classList.add('show__price');
        }
        
        if(document.querySelector('body.collection_replacement_localdata') && document.querySelector('.customize_product_price_content')) {
          if(document.querySelector('li.price_breakdown.price_lens_color .priceing_braekdown_label + span')) {
            let LensPrice = document.querySelector('li.price_breakdown.price_lens_color .priceing_braekdown_label + span');
            LensPrice = LensPrice.textContent.trim().split('+')[1];
            document.querySelectorAll('.replacement_pro_price').forEach(el => { el.textContent = LensPrice });
            // document.querySelector('.customize_product_price_content').removeAttribute('style');
            if(document.querySelector('.customize_product_price_content')) document.querySelector('.customize_product_price_content').classList.add('show__price');

            // document.querySelector('.product_sticky_content_data .replacement_pro_price').removeAttribute('style');
            document.querySelector('.product_sticky_content_data').classList.add('show__price');
          }
        }

        

      },100);
      // },300);
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  const tempVariantInUrl = urlParams.get('variant'); // <-- FIXED
  const hasVariantParam = !!tempVariantInUrl;
  // console.log(urlParams , "urlParams" ) ;

  if (!hasVariantParam) {
    // IF: URL does NOT contain ?variant
    
    const fitOption = document.querySelector('.product_option_fit_data');
    // if (fitOption) fitOption.click();
    if (fitOption) {
      setTimeout(()=> {
        fitOption.click();
      },500)
    }
    
    const frameColor = document.querySelector('.product_option_frame_color_data');
    // if (frameColor) frameColor.click();
    if (frameColor) {
      setTimeout(()=> {
        frameColor.click();
      },700)
    }

  } else {
    // ELSE: URL contains ?variant

    let matchedOptionNew = null;
    const variantOptionsNew = document.querySelectorAll('.customize_main_product_wrapper #ProductVariantSelectOptions select option');
    variantOptionsNew.forEach(option => {
      const optionValue = option.value; // variant ID
      if (optionValue === tempVariantInUrl) {
        matchedOptionNew = option;
        const optionFit = option.getAttribute('data-option-1')?.toLowerCase().trim();
        const optionFrameColor = option.getAttribute('data-option-2')?.toLowerCase().trim();

        
        setTimeout(()=>{
          document.querySelectorAll('.product_option_fit_data').forEach(function (elem) {
            const singleOptionframeFitSize = elem.getAttribute('option-value')?.toLowerCase().trim().split('_')[0];
            if (singleOptionframeFitSize === optionFit) elem.click();
          });
        },400)

        
        setTimeout(()=>{
          document.querySelectorAll('.product_option_frame_color_data').forEach(function (elem) {
            const singleOptionFrameColor = elem.getAttribute('option-value')?.toLowerCase().trim();
            if (singleOptionFrameColor === optionFrameColor) elem.click();
          });
        },600)

        // document.querySelectorAll('.product_option_fit_data').forEach(function (elem) {
        //   const singleOptionframeFitSize = elem.getAttribute('option-value')?.toLowerCase().trim().split('_')[0];
        //   if (singleOptionframeFitSize === optionFit) elem.click();
        // });

        // document.querySelectorAll('.product_option_frame_color_data').forEach(function (elem) {
        //   const singleOptionFrameColor = elem.getAttribute('option-value')?.toLowerCase().trim();
        //   if (singleOptionFrameColor === optionFrameColor) elem.click();
        // });
        
      }
    });

  }



  const NewPresValues = {};
  

  // *********************************   Start-LensBrand  ********************************* 
  let uniqueLensOptions;
  if (document.querySelectorAll('.product_option_brand').length > 0) {
        
        document.querySelectorAll('.product_option_brand_data').forEach(function (lensName) {

            if ((document.querySelector(".product_option_values_grid.option_values_grid_two").querySelectorAll("li").length) >= 1) {
                if (document.querySelectorAll('.all_brand_options').length > 0) {
                    document.querySelector('.lens_option_info_label').innerHTML = '';
                    document.querySelector('.lens_info_icon').setAttribute('info-label', '');
                    document.querySelector('.lens_option_info_head').classList.remove('lens_option_info_head_active')
                    document.querySelectorAll('.all_brand_options').forEach(allBrand_remove => allBrand_remove.classList.remove('all_brand_active'));
                    document.querySelectorAll('.product_option_values_grid.option_values_grid_three').forEach(el => el.classList.add('required_field'));
                    document.querySelectorAll(`#itg_properties_data input[name="properties[Lens Option]"]`).forEach(allBrand_remove => allBrand_remove.remove());
                    document.querySelector(".price_lens_color").innerHTML = '';
                    document.querySelector(".lens_color_info").innerHTML = '';
                    document.querySelector(".lens_features_info").innerHTML = '';
                }

                document.querySelectorAll('.product_option_brand_data').forEach(lensName_remove => lensName_remove.classList.remove('lens_name_active'))
                lensName.classList.add('lens_name_active');
                document.querySelector(".lens_brand_info").innerHTML = '';

                let lensbrandName = lensName.getAttribute('data-valuename').trim();
                let lensbrandValue = lensName.getAttribute('option-value').trim();
                lensName.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = lensbrandValue;
                lensName.closest('.product_option_values_grid').classList.remove('required_field');
                if(document.querySelector('.enter_prescription_details_head').classList.contains('enter_prescription_details_active')) EnableAddToCart();
                document.querySelector(".lens_brand_info").insertAdjacentHTML("beforeend", `<th>Lens Brand:</th><td>${lensbrandValue}</td>`);
                document.querySelectorAll(`#itg_properties_data input[name="${lensbrandName}"]`).forEach(lensName_remove => lensName_remove.remove());
                document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend", `<input type="hidden" name="${lensbrandName}" value="${lensbrandValue}">`);
                calPrice();

                let lensMatch = lensName.getAttribute('data-valuematch').trim();
                if (lensMatch) {
                    if (document.querySelectorAll('.product_option_brand_lens').length > 0) {
                        document.querySelectorAll('.product_option_brand_lens').forEach(lensdiv => lensdiv.classList.remove('product_option_brand_lens_active'));
                        document.querySelectorAll('.product_option_brand_lens').forEach(lensdiv => lensdiv.classList.add('product_option_brand_lens_active'));
                        document.querySelectorAll('.product_option_brand_lens_content').forEach(remove_active => remove_active.classList.remove('produc_brand_option_active'));
                        
                        if (document.querySelectorAll('.all_brand_options').length > 0) {
                            document.querySelectorAll('.all_brand_options').forEach(function (allBrand) {
                              allBrand.addEventListener('click', function (event) {
                                  let lensImage = event.target.closest(".product_option__value.all_brand_options").getAttribute('data-lensimage');
                                  let imageElement = document.querySelector('.customize_main_product_wrapper .Cookie_lenseimage .product-media-container .product__media.media img');
                                  if (imageElement) {
                                      imageElement.src = lensImage;
                                      imageElement.srcset = lensImage;
                                  }
                                  document.querySelector(".price_lens_color").innerHTML = '';
                                  document.querySelectorAll('.all_brand_options').forEach(allBrand_remove => allBrand_remove.classList.remove('all_brand_active'));
                                  allBrand.classList.add('all_brand_active');
                                  let allbrandName = allBrand.getAttribute('data-valuename');
                                  let allbrandValue = allBrand.getAttribute('option-value');
                                  let allbrandPrice = getTrustedPrice(allBrand, 'data-currlensprice'); // use trusted price so a tampered attribute can't blank the displayed price
                                  allBrand.closest('.product_option_values_head').querySelector('.produc_brand_option_active .product_option_selected_value').textContent = allbrandValue;
                                  allBrand.closest('.product_option_values_head').querySelectorAll('.product_option_values_grid').forEach(el => el.classList.remove('required_field'));
                                  if(document.querySelector('.enter_prescription_details_head').classList.contains('enter_prescription_details_active')) EnableAddToCart();
                                  document.querySelector(".lens_color_info").innerHTML = '';
                                  document.querySelector(".lens_color_info").insertAdjacentHTML("beforeend", `<th>Lens Color:</th><td>${allbrandValue}</td>`);
                                  document.querySelectorAll(`#itg_properties_data input[name="${allbrandName}"]`).forEach(allBrand_remove => allBrand_remove.remove());
                                  document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend", `<input type="hidden" name="${allbrandName}" value="${allbrandValue}">`);
                                  calPrice();
                                  let main_symbol = document.querySelector('.itg_main_product_temp').getAttribute('data-sym');
                                  document.querySelector(".price_lens_color").insertAdjacentHTML("beforeend", `<span class="richtext_regular_big itg_regular_big color_before_lines">|</span><span class="priceing_braekdown_label richtext_regular_big">Lens Color </span><span>${allbrandValue}+${main_symbol}${allbrandPrice}</span>`);
                                  document.querySelector('.lens_option_info_head').classList.add('lens_option_info_head_active');
                                  let colorType = allBrand.getAttribute('option-color-type');
                                  document.querySelector('.lens_option_info_label').innerHTML = colorType
                                  document.querySelector('.lens_info_icon').setAttribute('info-label', colorType.toLowerCase());
                                  document.querySelector(".lens_features_info").innerHTML = '';
                                  document.querySelector(".lens_features_info").insertAdjacentHTML("beforeend", `<th>Lens Features:</th><td>${colorType}</td>`);
                                  document.querySelector(".frameimage_list") ? document.querySelector(".frameimage_list").style.display = "none" : '';
                                  if (document.querySelector(".nonreplacement_localdata .no_frameimage_list")) {
                                      document.querySelector(".nonreplacement_localdata .no_frameimage_list").style.display = "flex";
                                  }
                                  EnableVisionType(allBrand);
                                  // console.log("all_brand_options ")
                                  if(document.querySelector('body.replacement_localdata')) {
                                    setTimeout(() => {
                                      if(document.querySelector('li.price_breakdown.price_lens_color .priceing_braekdown_label + span')) {
                                        let LensPrice = document.querySelector('li.price_breakdown.price_lens_color .priceing_braekdown_label + span');
                                        LensPrice = LensPrice.textContent.trim().split('+')[1];
                                        document.querySelectorAll('.replacement_pro_price').forEach(el => { el.textContent = LensPrice });
                                      }
                                    },100)
                                  }
                              });
                            });
                        }
                    }
                }
                const lensOptions = Array.from(document.querySelectorAll('.product_option_brand_lens_content.produc_brand_option_active .product_option__value.all_brand_options'));
                uniqueLensOptions = Array.from(new Set(lensOptions.map((element) => element.getAttribute('option-color-type').trim())));
            }

            lensName.addEventListener('click', function () {
                if (document.querySelectorAll('.all_brand_options').length > 0) {
                    document.querySelector('.lens_option_info_label').innerHTML = '';
                    document.querySelector('.lens_info_icon').setAttribute('info-label', '');
                    document.querySelector('.lens_option_info_head').classList.remove('lens_option_info_head_active')
                    document.querySelectorAll('.all_brand_options').forEach(allBrand_remove => allBrand_remove.classList.remove('all_brand_active'));
                    document.querySelectorAll('.product_option_values_grid.option_values_grid_three').forEach(el => el.classList.add('required_field'));
                    document.querySelectorAll(`#itg_properties_data input[name="properties[Lens Option]"]`).forEach(allBrand_remove => allBrand_remove.remove());
                    document.querySelector(".price_lens_color").innerHTML = '';
                    document.querySelector(".lens_color_info").innerHTML = '';
                    document.querySelector(".lens_features_info").innerHTML = '';
                }
                document.querySelectorAll('.product_option_brand_data').forEach(lensName_remove => lensName_remove.classList.remove('lens_name_active'))
                lensName.classList.add('lens_name_active');
                document.querySelector(".lens_brand_info").innerHTML = '';
                let lensbrandName = lensName.getAttribute('data-valuename').trim();
                let lensbrandValue = lensName.getAttribute('option-value').trim();
                lensName.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = lensbrandValue;
                lensName.closest('.product_option_values_grid').classList.remove('required_field');
                EnableAddToCart();
                document.querySelector(".lens_brand_info").insertAdjacentHTML("beforeend", `<th>Lens Brand:</th><td>${lensbrandValue}</td>`);
                document.querySelectorAll(`#itg_properties_data input[name="${lensbrandName}"]`).forEach(lensName_remove => lensName_remove.remove());
                document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend", `<input type="hidden" name="${lensbrandName}" value="${lensbrandValue}">`);
                calPrice();
                let lensMatch = lensName.getAttribute('data-valuematch').trim();
                if (lensMatch) {
                    if (document.querySelectorAll('.product_option_brand_lens').length > 0) {
                        document.querySelectorAll('.product_option_brand_lens').forEach(lensdiv => lensdiv.classList.remove('product_option_brand_lens_active'));
                        document.querySelectorAll('.product_option_brand_lens').forEach(lensdiv => lensdiv.classList.add('product_option_brand_lens_active'));
                        document.querySelectorAll('.product_option_brand_lens_content').forEach(remove_active => remove_active.classList.remove('produc_brand_option_active'));
                        document.querySelectorAll('.product_option_brand_lens_content').forEach(function (lensOption) {
                            let lensmatchName = lensOption.getAttribute('brand-name').trim();
                            if (lensMatch == lensmatchName) {
                                lensOption.classList.add('produc_brand_option_active');
                            }
                        });

                      
                      // ---------------------- LENS OPTIONS -------------------------------
                        if (document.querySelectorAll('.all_brand_options').length > 0) {
                            document.querySelectorAll('.all_brand_options').forEach(function (allBrand) {
                                allBrand.addEventListener('click', function () {
                                    document.querySelector(".price_lens_color").innerHTML = '';
                                    document.querySelectorAll('.all_brand_options').forEach(allBrand_remove => allBrand_remove.classList.remove('all_brand_active'));
                                    allBrand.classList.add('all_brand_active');
                                    let allbrandName = allBrand.getAttribute('data-valuename');
                                    let allbrandValue = allBrand.getAttribute('option-value');
                                    let allbrandPrice = getTrustedPrice(allBrand, 'data-currlensprice'); // use trusted price so a tampered attribute can't blank the displayed price
                                    allBrand.closest('.product_option_values_head').querySelector('.produc_brand_option_active .product_option_selected_value').textContent = allbrandValue;
                                    allBrand.closest('.product_option_values_head').querySelectorAll('.product_option_values_grid').forEach(el => el.classList.remove('required_field'));
                                    if(document.querySelector('.enter_prescription_details_head').classList.contains('enter_prescription_details_active')) EnableAddToCart();
                                    document.querySelector(".lens_color_info").innerHTML = '';
                                    document.querySelector(".lens_color_info").insertAdjacentHTML("beforeend", `<th>Lens Color:</th><td>${allbrandValue}</td>`);
                                    document.querySelectorAll(`#itg_properties_data input[name="${allbrandName}"]`).forEach(allBrand_remove => allBrand_remove.remove());
                                    document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend", `<input type="hidden" name="${allbrandName}" value="${allbrandValue}">`);
                                    calPrice();
                                    let main_symbol = document.querySelector('.itg_main_product_temp').getAttribute('data-sym');
                                    document.querySelector(".price_lens_color").insertAdjacentHTML("beforeend", `<span class="richtext_regular_big itg_regular_big color_before_lines">|</span><span class="priceing_braekdown_label richtext_regular_big">Lens Color </span><span>${allbrandValue}+${main_symbol}${allbrandPrice}</span>`);
                                    document.querySelector('.lens_option_info_head').classList.add('lens_option_info_head_active');
                                    let colorType = allBrand.getAttribute('option-color-type');
                                    document.querySelector('.lens_option_info_label').innerHTML = colorType
                                    document.querySelector('.lens_info_icon').setAttribute('info-label', colorType.toLowerCase());
                                    document.querySelector(".lens_features_info").innerHTML = '';
                                    document.querySelector(".lens_features_info").insertAdjacentHTML("beforeend", `<th>Lens Features:</th><td>${colorType}</td>`);
                                    if (NewPresValues?.pdValue !== '' && NewPresValues?.pdValue !== undefined && NewPresValues?.pdValue !== null ) {
                                        if(document.querySelector('.enter_prescription_details_head').classList.contains('enter_prescription_details_active')) PrescriptionCalculation();
                                    }  
                                });
                            });
                        }
                    }
                }

                const lensOptions = Array.from(document.querySelectorAll('.product_option_brand_lens_content.produc_brand_option_active .product_option__value.all_brand_options'));
                uniqueLensOptions = Array.from(new Set(lensOptions.map((element) => element.getAttribute('option-color-type').trim())));

                // ---------------Change all SELECT on brand Selecting ------------------
                document.querySelectorAll('.vision_type_and_prescripiton_wrapper select').forEach(selectOption => {
                    if (lensbrandValue.toLowerCase().trim() === 'sunberryrx') {
                        if (selectOption.classList.contains('Sunberry_Option')) {
                            selectOption.classList.remove('hide_brand_option');
                            if (selectOption.classList.contains('product-custom-option')) {
                                selectOption.classList.add('pd_required');
                            }
                            else if (selectOption.classList.contains('sphere_value_list')) {
                                selectOption.classList.add('required_field');
                            }
                            else if (selectOption.classList.contains('select_for_axis')) {
                                selectOption.classList.add('required_axis_field');
                            }
                        }
                        else if (selectOption.classList.contains('Luxottica_Option')) {
                            selectOption.classList.remove('required_field', 'pd_required', 'required_axis_field');
                            selectOption.classList.add('hide_brand_option');
                        }
                    }
                    else {
                        if (selectOption.classList.contains('Luxottica_Option')) {
                            selectOption.classList.remove('hide_brand_option');
                            if (selectOption.classList.contains('product-custom-option')) {
                                selectOption.classList.add('pd_required');
                            }
                            else if (selectOption.classList.contains('sphere_value_list')) {
                                selectOption.classList.add('required_field');
                            }
                            else if (selectOption.classList.contains('select_for_axis')) {
                                selectOption.classList.add('required_axis_field');
                            }
                        }
                        else if (selectOption.classList.contains('Sunberry_Option')) {
                            selectOption.classList.remove('required_field', 'pd_required', 'required_axis_field');
                            selectOption.classList.add('hide_brand_option');
                        }
                    }
                })

                document.querySelector('.product_option_values_head.product_option_brand_lens').classList.add('option_required_before_prescription');
                document.querySelector('.product_option_vision_type .product_option_values_grid').classList.add('disabled-vision-type');
                document.querySelector('.product_option_values_head.product_option_precipiton').classList.remove('product_option_precipiton_active');
                document.querySelectorAll('.product_option__value.vision_type_item').forEach(el => el.classList.remove('vision_type_active'));
                document.querySelector('.customize_main_product_wrapper .vision_type_and_prescripiton_inner > .enter_prescription_details_head ').classList.remove('enter_prescription_details_active');
                document.querySelector('.customize_main_product_wrapper .enter_prescription_prism_correction .enter_prescription_details_head').classList.remove('prism_correction_active');
                document.querySelector('.customize_main_product_wrapper .enter_prescription_prism_correction').style.display = 'none';
                document.querySelector('#PrismCorrection[type="checkbox"]').checked = false;
                EnableVisionType(lensName);

                document.querySelectorAll('select.sphere_enter').forEach(select => select.value = '');
                document.querySelector('#itg_properties_data input[name="properties[_right_sphere]"]')?.remove();
                document.querySelector('#itg_properties_data input[name="properties[_left_sphere]"]')?.remove();
                document.querySelector('#itg_properties_data input[name="properties[_right_cylinder]"]')?.remove();
                document.querySelector('#itg_properties_data input[name="properties[_left_cylinder]"]')?.remove();
                document.querySelector('#itg_properties_data input[name="properties[_right_add]"]')?.remove();
                document.querySelector('#itg_properties_data input[name="properties[_left_add]"]')?.remove();
                if(document.querySelector('#ThinLensNotSelected')) { document.querySelector('#ThinLensNotSelected').style.display = 'none'; }



                // ------------- Change Progressive Lens Price according to Selected Brand -------------
                 if(document.querySelector('body').classList.contains('replacement_localdata')) {
                     if(document.querySelector(`.vision_type_and_prescripiton_wrapper [id*=${lensbrandValue}Replacement]`)) {
                        const brandProgressivePrice = Number(document.querySelector(`.vision_type_and_prescripiton_wrapper [id*=${lensbrandValue}Replacement]`).textContent);
                        document.querySelector('.vision_type_item[option-value="Progressive"]').setAttribute('data-currvisionprice', brandProgressivePrice.toFixed(2));
                        setTrustedPrice(document.querySelector('.vision_type_item[option-value="Progressive"]'), brandProgressivePrice.toFixed(2)); // mirror legit price into trusted store (Part 1)
                        document.querySelector('.vision_type_item[option-value="Progressive"]').setAttribute('data-visionprice', brandProgressivePrice);
                        const brandProgressivePriceCurrency = document.querySelector(`.vision_type_and_prescripiton_wrapper #ProgressiveLensPrice`).getAttribute('data-price-currency');
                        document.querySelector('.vision_type_item #ProgressiveLensPrice').textContent = `+ ${brandProgressivePriceCurrency+brandProgressivePrice}`
                     }
                 }
                 else {
                    if(document.querySelector(`.vision_type_and_prescripiton_wrapper [id*=${lensbrandValue}]`)) {
                      const brandProgressivePrice = Number(document.querySelector(`.vision_type_and_prescripiton_wrapper [id*=${lensbrandValue}]`).textContent);
                      document.querySelector('.vision_type_item[option-value="Progressive"]').setAttribute('data-currvisionprice', brandProgressivePrice.toFixed(2));
                      setTrustedPrice(document.querySelector('.vision_type_item[option-value="Progressive"]'), brandProgressivePrice.toFixed(2)); // mirror legit price into trusted store (Part 1)
                      document.querySelector('.vision_type_item[option-value="Progressive"]').setAttribute('data-visionprice', brandProgressivePrice);
                      const brandProgressivePriceCurrency = document.querySelector(`.vision_type_and_prescripiton_wrapper #ProgressiveLensPrice`).getAttribute('data-price-currency');
                      document.querySelector('.vision_type_item #ProgressiveLensPrice').textContent = `+ ${brandProgressivePriceCurrency+brandProgressivePrice}`
                    }
                 }
                // ------------- Change Progressive Lens Price according to Selected Brand -------------

              
                
              
            });

        });
        
  }
  
  if(document.querySelector('body.nonreplacement_localdata')) {
    document.addEventListener('click',function (e){
      if(e.target.closest('.product_option_brand_lens_content li.all_brand_options')) {
        if (!document.querySelector('.product_option__value.product_option_frame_color_data.frame_color_active')) {
          alert('Please Select Frame Color...');
        }
      }
    })
  }

  // *********************************  End-LensBrand  *********************************
  


  let pdValue = null;
  let PresValues = {} ;
  let PresPDValues = {} ;
   
  // *********************************  Start-vision-type  *********************************
  if(document.querySelectorAll('.vision_type_and_prescripiton_wrapper').length > 0) {
      let productOptionPrecipiton = document.querySelector('.product_option_precipiton');
      document.querySelectorAll('.vision_type_item').forEach(function(visionType){
          visionType.addEventListener('click',function(){
              document.querySelectorAll(`#itg_properties_data input[name="properties[Upload]"]`).forEach(uploadName_remove => uploadName_remove.remove());
              if(document.querySelectorAll('.enter_prescription_details_head').length > 0){
                document.querySelector('.enter_prescription_details_head').classList.remove('enter_prescription_details_active');
                document.querySelectorAll('.itg_presecripiton_button').forEach(enterButton => enterButton.classList.remove('product_option__value_active'));
              }
              document.querySelectorAll('.vision_type_item ').forEach(visionType_remove => visionType_remove.classList.remove('vision_type_active'));
              visionType.classList.add('vision_type_active');
              let visionOptionName = this.getAttribute('data-valuename');
              let visionOptionValue = this.getAttribute('option-value');
              visionType.closest('.product_option_values_head').querySelector('.product_option_selected_value').textContent = visionOptionValue;
              visionType.closest('.product_option_values_grid').classList.remove('required_field');
              document.querySelector('.enter_prescription_prism_correction').style.display = 'none';
              EnableAddToCart()
              let visionOptionPrice = getTrustedPrice(this, 'data-currvisionprice'); // use trusted price so a tampered attribute can't blank the displayed price
              document.querySelectorAll(`#itg_properties_data input[name="${visionOptionName}"]`).forEach(visionType_remove => visionType_remove.remove());
              document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="${visionOptionName}" value="${visionOptionValue}">`);
              document.querySelector(`#itg_properties_data input[name="properties[_right_focality]"]`).value = document.querySelector('.vision_type_item.vision_type_active').getAttribute('data-right-focality');
              document.querySelector(`#itg_properties_data input[name="properties[_left_focality]"]`).value = document.querySelector('.vision_type_item.vision_type_active').getAttribute('data-right-focality');
              productOptionPrecipiton.classList.add('product_option_precipiton_active');
              if(visionOptionValue.trim().toLowerCase() === 'single vision'){
                document.querySelector('.progressive_prescription_table').classList.remove('active_prescription_table'); 
                document.querySelector('.progressive_pupillary_content').classList.remove('active_puppilary_content'); 
                document.querySelector('.single_vision_prescription_table').classList.add('active_prescription_table'); 
                document.querySelector('.single_vision_pupillary_content').classList.add('active_puppilary_content'); 
              }
              else if(visionOptionValue.trim().toLowerCase() === 'progressive'){
                document.querySelector('.single_vision_prescription_table').classList.remove('active_prescription_table'); 
                document.querySelector('.single_vision_pupillary_content').classList.remove('active_puppilary_content'); 
                document.querySelector('.progressive_prescription_table').classList.add('active_prescription_table'); 
                document.querySelector('.progressive_pupillary_content').classList.add('active_puppilary_content'); 
              } 
              document.querySelectorAll('.pd_distance_content.pd_distance_content_active').forEach(el => el.classList.remove('pd_distance_content_active'));
              document.querySelectorAll('.pd_number_input_item.pd_number_input_item_active').forEach(el => el.classList.remove('pd_number_input_item_active'));
              // document.querySelectorAll('.pd_number_inner .pd_number_input_grid').forEach(el => el.classList.add('disabled-pd'));
              document.querySelector(".price_breakdown_progressive").innerHTML = '';
              if(visionOptionPrice != 0){
                let main_symbol = document.querySelector('.itg_main_product_temp').getAttribute('data-sym');
                document.querySelector(".price_breakdown_progressive").insertAdjacentHTML("beforeend",`<span class="richtext_regular_big itg_regular_big">|</span><span class="priceing_braekdown_label richtext_regular_big">Progressive </span
                    ><span>+${main_symbol}${visionOptionPrice}</span>`);
              }
              calPrice();
            
              PresValues = {} ;
              PresPDValues = {} ;

              if (document.querySelectorAll('.product_option_brand_data.lens_name_active').length === 0) {
                document.querySelectorAll('.product_option_brand_data').forEach(function(brandName) {
                    if (brandName.getAttribute('option-value').trim() === 'Sunberryrx') {
                        brandName.click();
                        setTimeout(()=>{
                          document.querySelectorAll('.product_option_brand_lens_content.produc_brand_option_active .all_brand_options')[0].click();
                        },300)
                    } else {
                        document.querySelector('.product_option_brand_data:first-child').click();
                        setTimeout(()=>{
                          document.querySelectorAll('.product_option_brand_lens_content.produc_brand_option_active .all_brand_options')[0].click();
                        },300)
                    }
                });
              }

              if(visionOptionValue.toLowerCase().includes('single')) {
                document.querySelector('#itg_properties_data [name="properties[__right_add]"]')?.remove();
                document.querySelector('#itg_properties_data [name="properties[_left_add]"]')?.remove();
                document.querySelectorAll('.progressive_prescription_table [name="properties[_right_add]"]').forEach(select => select.value = '');
                document.querySelectorAll('.progressive_prescription_table [name="properties[_left_add]"]').forEach(select => select.value = '');
              }
            
            document.querySelector('#itg_properties_data [name="properties[_Combined Right SPH]"]')?.remove();
            document.querySelector('#itg_properties_data [name="properties[_Combined Left SPH]"]')?.remove();
            document.querySelector('.customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons').classList.add('disabled-cart-button');
            pdValue = null; 
            
          });
      });
  }
  // *********************************  End-vision-type  *********************************


  
  // ********************************* Start Prescription Helping Functions and Variables *********************************

  let isThinLensSelected = false;
  let isSphereRangeChanged  = false;
  let isAllAxisFilled  = false;
    
  // EnableAddToCart *******************************
  function EnableAddToCart() {
    let addToCartButton = document.querySelector('.customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons');
    let OtherRequiredFields = document.querySelectorAll('.product_option_values_grid.required_field');
    let EnterPrescriptionWrapper = document.querySelector('.product_option__value.enter_prescription.product_option__value_active');
    let EnterPrescriptionWrapperLength = document.querySelectorAll('.product_option__value.enter_prescription.product_option__value_active').length;
    
    if(!SelectedVariantAvailable) return;
    if(OtherRequiredFields.length == 0) addToCartButton.classList.remove('disabled-cart-button');
    else addToCartButton.classList.add('disabled-cart-button');
    

    if(EnterPrescriptionWrapper && (EnterPrescriptionWrapperLength > 0) && (OtherRequiredFields.length == 0)) {
    
      addToCartButton.classList.add('disabled-cart-button');
      let prism_correction_active = document.querySelector('#PrismCorrection').checked;
      let selects = document.querySelectorAll('.enter_prescription_table_head.active_prescription_table .sphere_enter.required_field');
      let allPrescriptionSelected = Array.from(selects).every(select => select.value.trim() !== "");
      
      let activePdOption = document.querySelector('.pd_number_inner.active_puppilary_content .pd_number_input_item.pd_number_input_item_active');
      let allPDSelected = false; 
      if (activePdOption) {
          let selectedPdType = activePdOption.getAttribute('pd-title');
          if (selectedPdType === "no_pds") { allPDSelected = true; } 
          else {
              let selectFields = [];
              if (selectedPdType === "pd_one") {
                  selectFields = document.querySelectorAll('.pd_number_inner.active_puppilary_content .pd_distance_content[pd-content="pd_one"] select.pd_required');
              } else if (selectedPdType === "pd_two") {
                  selectFields = document.querySelectorAll('.pd_number_inner.active_puppilary_content .pd_distance_content[pd-content^="pd_two"] select.pd_required');
              }
              allPDSelected = Array.from(selectFields).every(select => select.value.trim() !== "");
          }
      }

    
      if(prism_correction_active) {
        let prismSelects = document.querySelectorAll('.customize_main_product_wrapper .enter_prescription_prism_correction .prism_correction_active .sphere_enter.required_field')
        let prismValuesSelected = Array.from(prismSelects).every(select => select.value.trim() != '');
        if (isSphereRangeChanged) {
          if (allPrescriptionSelected && allPDSelected && prismValuesSelected && isThinLensSelected && isAllAxisFilled) addToCartButton.classList.remove('disabled-cart-button');
          else addToCartButton.classList.add('disabled-cart-button');
        }
        else {
          if (allPrescriptionSelected && allPDSelected && prismValuesSelected && isAllAxisFilled) addToCartButton.classList.remove('disabled-cart-button');
          else addToCartButton.classList.add('disabled-cart-button');
        }
      }
      else {
        if (isSphereRangeChanged) {
          if (allPrescriptionSelected && allPDSelected && isThinLensSelected && isAllAxisFilled) addToCartButton.classList.remove('disabled-cart-button');
          else addToCartButton.classList.add('disabled-cart-button');
        }
        else {
          if (allPrescriptionSelected && allPDSelected && isAllAxisFilled) addToCartButton.classList.remove('disabled-cart-button');
          else addToCartButton.classList.add('disabled-cart-button');
        }
      }
    }
    
    // if(!document.querySelector('.product_option__value.product_option_frame_color_data.frame_color_active')) {
    //   addToCartButton.classList.add('disabled-cart-button');
    // }
    // if(!document.querySelector('.product_option__value.vision_type_item.vision_type_active')) {
    //   addToCartButton.classList.add('disabled-cart-button');
    // }
    // if(!document.querySelector('.product_option__value.prescription_type_item.product_option__value_active')) {
    //   addToCartButton.classList.add('disabled-cart-button');
    // }
    if(document.querySelector('body.nonreplacement_localdata')) {
      if (
        !document.querySelector('.product_option__value.product_option_frame_color_data.frame_color_active') ||
        !document.querySelector('.product_option__value.vision_type_item.vision_type_active') ||
        !document.querySelector('.product_option__value.prescription_type_item.product_option__value_active')
      ) {
        addToCartButton.classList.add('disabled-cart-button');
      }
      if(!document.querySelector('.product_option__value.product_option_frame_color_data.frame_color_active')) alert('Please Select Frame Color...');
    }

  }
    
  // Get Prescription Values *******************************
  function getPrescriptionValues(enter_prescription_table) {
    PresValues = {};
  
    const cylinderRightElement = enter_prescription_table.querySelector('[name="properties[_right_cylinder]"]');
    const cylinderRightLimit = parseFloat(cylinderRightElement?.dataset.rangeLimit || '0');
    const cylinderRightValue = parseFloat(cylinderRightElement?.value || '0');
    const cylinderRight = cylinderRightValue > cylinderRightLimit ? cylinderRightValue.toString() : '';
  
    const sphereRightElement = enter_prescription_table.querySelector('[name="properties[_right_sphere]"]');
    const sphereRightLimit = parseFloat(sphereRightElement?.dataset.rangeLimit || '0');
    const sphereRightValue = parseFloat(sphereRightElement?.value || '0');
    const sphereRight = sphereRightValue > sphereRightLimit ? sphereRightValue.toString() : '';
  
    const cylinderLeftElement = enter_prescription_table.querySelector('[name="properties[_left_cylinder]"]');
    const cylinderLeftLimit = parseFloat(cylinderLeftElement?.dataset.rangeLimit || '0');
    const cylinderLeftValue = parseFloat(cylinderLeftElement?.value || '0');
    const cylinderLeft = cylinderLeftValue > cylinderLeftLimit ? cylinderLeftValue.toString() : '';
  
    const sphereLeftElement = enter_prescription_table.querySelector('[name="properties[_left_sphere]"]');
    const sphereLeftLimit = parseFloat(sphereLeftElement?.dataset.rangeLimit || '0');
    const sphereLeftValue = parseFloat(sphereLeftElement?.value || '0');
    const sphereLeft = sphereLeftValue > sphereLeftLimit ? sphereLeftValue.toString() : '';
  
    return { cylinderRight, sphereRight, cylinderLeft, sphereLeft };
  }
      
  // Get Pd Values *******************************
  function getPdValues(enter_pd_content) {
      PresPDValues = {};
      if(enter_pd_content.getAttribute('pd-title') == 'no_pds'){
        const no_pds = 'no_pds';
        return { no_pds };
      }
      else if(enter_pd_content.getAttribute('pd-content') == 'pd_one'){
        const pd = enter_pd_content?.querySelector('[name="properties[_right_pd_dist]"]')?.value || enter_pd_content?.querySelector('[name="properties[_left_pd_dist]"]')?.value || '';
        return { pd };
      }
      else if(enter_pd_content.getAttribute('pd-content') == 'pd_two') {
        const pdRight = enter_pd_content?.querySelector('[name="properties[_right_pd_dist]"]')?.value || '';
        const pdLeft = enter_pd_content?.querySelector('[name="properties[_left_pd_dist]"]')?.value || '';
        return { pdLeft, pdRight };
      }
      else {
        return {};
      }
  }
 
  // File Input Handling *******************************
  if(document.querySelectorAll('.prescription_type_item_upload').length > 0) {
    document.addEventListener("change", function (event) {
      if (event.target.id === "presciption_file_input") {
          if(document.querySelectorAll('.enter_prescription_details_head').length > 0){
            document.querySelector('.enter_prescription_details_head').classList.remove('enter_prescription_details_active');
            document.querySelectorAll('.itg_presecripiton_button').forEach(enterButton => enterButton.classList.remove('product_option__value_active'));
            document.querySelector('.product_option__value.prescription_type_item_upload').classList.add('product_option__value_active');
            document.querySelector('.enter_prescription_prism_correction').style.display = 'none';
          }
        
          let isFileTypeImage = false;
          let inputElement = event.target;
          if(inputElement.value !== ''){
              document.querySelector('.addLoader').classList.add('it_loading');
              let form_data = new FormData();
              let file_data = inputElement.files[0];
              form_data.append('image', file_data);

              let uploadedFileURL = null;
              var xhr = new XMLHttpRequest();
              xhr.open("POST", "https://sunberryrx.store/storefront/file.php", true);
              xhr.onload = function () {
                if(xhr.status === 200) {
                  uploadedFileURL = xhr.responseText;
                  document.querySelectorAll(`#itg_properties_data input[name="properties[Upload]"]`).forEach(uploadName_remove => uploadName_remove.remove());
                  document.querySelectorAll(`#itg_properties_data input[name="properties[Prescription]"]`).forEach(uploadName_remove => uploadName_remove.remove());
                  document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[Upload]" value="${uploadedFileURL}">`);
                  document.querySelector('.addLoader').classList.remove('it_loading');
                  inputElement.closest('.product_option_values_grid').classList.remove('required_field');
                  EnableAddToCart();
                }else{
                  document.querySelector('.addLoader').classList.remove('it_loading');
                }
              }
              xhr.onerror = function () {};
              xhr.send(form_data);
  
              if(file_data.type.startsWith('image/')) {
                  const reader = new FileReader();
                  reader.onload = function (event) {
                    const imgTag = document.createElement('img');
                    imgTag.src = event.target.result;
                    imgTag.alt = file_data.name; 
                    imgTag.style.maxWidth = '100px'; 
                    imgTag.style.marginTop = '10px';
                    inputElement.closest('.product_option_precipiton').querySelector('.UploadedImgTopWr').style.display = 'flex';
                    inputElement.closest('.product_option_precipiton').querySelector('.UploadedImgWr').innerHTML = '';
                    inputElement.closest('.product_option_precipiton').querySelector('.UploadedImgWr').appendChild(imgTag);

                    let RemoveUploadedImg = document.querySelector('.RemoveUploadedImg')
                    RemoveUploadedImg.addEventListener('click', function () {
                      imgTag.remove(); // Remove the image wrapper
                      inputElement.value = ''; // Reset the file input
                      document.querySelectorAll(`#itg_properties_data input[name="properties[Upload]"]`).forEach(input => input.remove());
                      inputElement.closest('.product_option_precipiton').querySelector('.UploadedImgTopWr').style.display = 'none';
                      inputElement.closest('.product_option_values_grid').classList.add('required_field');
                      document.querySelectorAll('.prescription_type_item_upload').forEach(enterButton => enterButton.classList.remove('product_option__value_active'));
                      EnableAddToCart();
                    });
                  };
                  reader.readAsDataURL(file_data);
              } 
              else {
                let FileNameToAdd = `<a href="${uploadedFileURL}" target="_blank" class="UploadedFileData">Uploaded Prescription</a>`;
                inputElement.closest('.product_option_precipiton').querySelector('.UploadedImgTopWr').style.display = 'flex';
                inputElement.closest('.product_option_precipiton').querySelector('.UploadedImgWr').innerHTML = FileNameToAdd;
              
                let RemoveUploadedImg = document.querySelector('.RemoveUploadedImg')
                RemoveUploadedImg.addEventListener('click', function () {
                  let FileNameAdded = document.querySelector('.UploadedFileData');
                  FileNameAdded.remove(); // Remove the image wrapper
                  inputElement.value = ''; // Reset the file input
                  document.querySelectorAll(`#itg_properties_data input[name="properties[Upload]"]`).forEach(input => input.remove()); // Remove uploaded image hidden input
                  inputElement.closest('.product_option_precipiton').querySelector('.UploadedImgTopWr').style.display = 'none';
                  inputElement.closest('.product_option_values_grid').classList.add('required_field');
                  document.querySelectorAll('.prescription_type_item_upload').forEach(enterButton => enterButton.classList.remove('product_option__value_active'));
                  EnableAddToCart();
                });
                
              }
            
          }
      }
    });
  }
  
  // File and Send Later Handling *******************************
  if(document.querySelectorAll('.itg_presecripiton_button').length > 0) {
    document.querySelectorAll('.itg_presecripiton_button').forEach(function(enterPresecripiton) {
      enterPresecripiton.addEventListener('click',function() {
        document.querySelector('.enter_prescription_details_head').classList.remove('enter_prescription_details_active');
        document.querySelectorAll('.itg_presecripiton_button').forEach(enterButton => enterButton.classList.remove('product_option__value_active'));
        document.querySelector('.product_option__value.prescription_type_item_upload').classList.remove('product_option__value_active');
        document.querySelectorAll(`#itg_properties_data input[name="properties[Upload]"]`).forEach(uploadName_remove => uploadName_remove.remove());
        document.querySelector('[data-valuename="properties[Upload]"]').value = '';
        document.querySelector('.product_option_precipiton .UploadedImgWr').innerHTML = '';
        document.querySelector('.product_option_precipiton .UploadedImgTopWr').style.display = 'none';
        document.querySelectorAll(`#itg_properties_data input[name="properties[Prescription]"]`).forEach(uploadName_remove => uploadName_remove.remove());
        this.classList.add('product_option__value_active');
        let presecripitonType = this.getAttribute('option-value');
        if(presecripitonType.match('enter-prescription')){
          document.querySelector('.enter_prescription_details_head').classList.add('enter_prescription_details_active');
        }
        if(this.closest('.send_later')){
          document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[Prescription]" value="Send Later">`);
          document.querySelector('.enter_prescription_prism_correction').style.display = 'none';
        }
        else if(this.closest('.itg_presecripiton_button.enter_prescription')){
          document.querySelector('.enter_prescription_prism_correction').style.display = 'block';
        }
        this.closest('.product_option_values_grid').classList.remove('required_field');
        EnableAddToCart();
      });
    });
  }

  // Sphere Value Enter *******************************
  if(document.querySelectorAll('.sphere_enter').length > 0) {
    document.querySelectorAll('.sphere_enter').forEach(function(enterNow) {
      enterNow.addEventListener('change',function() {
        let sphereName = enterNow.getAttribute('name');
        let LensBrand = document.querySelector('.product_option_brand .lens_name_active')?.getAttribute('option-value').trim();
      
        if(sphereName.includes('axis')) {
          let sphereSelect = enterNow.closest('.prescription_sphere_head').previousElementSibling.querySelector('.sphere_enter.required_field');
          let cylinderSelect = enterNow.closest('.prescription_sphere_head').previousElementSibling.previousElementSibling.querySelector('.sphere_enter.required_field');
          if(sphereSelect.value === '' && cylinderSelect.value === '' ) {
            alert('Please Select Sphere and Cylinder First.');
            enterNow.value = '';
          }
          else if(sphereSelect.value === '') {
            alert('Please select a Cylinder value. If you do not have a Cylinder value, please select 0.00.');
            enterNow.value = '';
          }
          else if(cylinderSelect.value === '') {
            alert('Please Select Sphere First.');
            enterNow.value = '';
          }
        }
      
        document.querySelectorAll(`#itg_properties_data input[name="${sphereName}"]`).forEach(rightEnter_remove => rightEnter_remove.remove());
        if(enterNow.value){
          let sphereVal = enterNow.value;
          document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="${sphereName}" value="${sphereVal}">`);
          if(sphereName.toLowerCase().includes('axis') && !enterNow.closest('.prism_correction_active')){
            enterNow.closest('tr').querySelector('td:last-child').classList.remove('disabled-add')
          }
        }
        else{
          if(sphereName.toLowerCase().includes('axis') && !enterNow.closest('.prism_correction_active')  && !enterNow.closest('.single_vision_prescription_table') ){
            enterNow.closest('tr').querySelector('td:last-child').classList.add('disabled-add')
          }
        }

        let enter_prescription_table = enterNow.closest('.enter_prescription_table')
        if(enterNow.closest('.required_field')) {
          PresValues = getPrescriptionValues(enter_prescription_table);
        }
        
        if(enterNow.closest('.prism_correction_active')){
          let isAllPrismSelectsFilled = Array.from(document.querySelectorAll('.prism_correction_active .sphere_enter')).every(select => select.value.trim() !== '');
          if(isAllPrismSelectsFilled) PrescriptionCalculation();
          if(enterNow.value.trim() === '') {
            document.querySelector('.customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons').classList.add('disabled-cart-button');
          }
        } 
        else {
          let includingClassName = LensBrand.includes('Sunberryrx') ? 'Sunberry_Option': 'Luxottica_Option';
          if(sphereName.includes('cylinder')) {
            const nearAxis = enterNow.closest('tr').querySelector(`.select_for_axis.${includingClassName}`);
            if(enterNow.value.trim() === '') nearAxis.value = '';
            if( enterNow.value !== '' && Number(enterNow.value) === 0 ) nearAxis.classList.remove('required_axis_field');
            else if( (enterNow.value === '' && nearAxis.value ==='') || (Number(enterNow.value) !== 0 && nearAxis.value ==='') ) nearAxis.classList.add('required_axis_field');
            EnableAddToCart();
          }
          if(sphereName.includes('axis')) {
            const nearCylinder = enterNow.closest('tr').querySelector(`.${includingClassName}[name*="_cylinder"]`);
            if(enterNow.value.trim() !== '' && nearCylinder.value !== "") enterNow.classList.remove('required_axis_field');
            else if( enterNow.value.trim() === '' && Number(nearCylinder.value) !== 0 )enterNow.classList.add('required_axis_field');
          }

          const requiredAxisSelects = document.querySelectorAll('.active_prescription_table .required_axis_field');
          isAllAxisFilled = Array.from(requiredAxisSelects).every(select => select.value.trim() !== '');
          if(!isAllAxisFilled) {
            document.querySelector('.active_puppilary_content .pd_number_input_item_active')?.classList.remove('pd_number_input_item_active');  
            document.querySelector('.active_puppilary_content .pd_distance_content_active')?.classList.remove('pd_distance_content_active');  
          }
          
          const requiredSphCylSelects = document.querySelectorAll('.active_prescription_table select.required_field');
          const isAllSphCylFilled = Array.from(requiredSphCylSelects).every(select => select.value.trim() !== '');
          if(isAllSphCylFilled) {
            PrescriptionCalculation();
            CalculateCombinedPower();
          }
        }
        
        // console.log(PresValues);

        const getInputValue = (selector) => {
          const input = document.querySelector(selector);
          return input ? parseFloat(input.value.trim()) : "";
        };

        let cylinderRightValue = getInputValue('#itg_properties_data input[name="properties[_right_cylinder]"]') ;
        let cylinderLeftValue = getInputValue('#itg_properties_data input[name="properties[_left_cylinder]"]');
        
        if(!LensBrand.includes('Sunberryrx')) {
          if(cylinderRightValue > 3 || cylinderLeftValue > 3 || cylinderRightValue < -3 || cylinderLeftValue < -3 ) {
            // const msgToShow = 'We’re sorry! The prescription you entered === is outside the range we offer for sunglasses in this brand. Need help? Contact us at <a href="mailto:info@sunberryrx.com">info@sunberryrx.com</a>'
            const msgToShow = document.querySelector('.product__info-wrapper .outside_range_header').innerHTML;
            showNotAvailabilityPopup(msgToShow);
            document.querySelector('.cstm_customize__product .prescription_product_overlay').classList.remove('prescription_product_overlay_active');
            return;
          }

          let rightAddValue = getInputValue('#itg_properties_data input[name="properties[_right_add]"]')
          let leftAddValue = getInputValue('#itg_properties_data input[name="properties[_left_add]"]')
          let prismRightSphereValue = getInputValue('#itg_properties_data input[name="properties[_Prism Sphere right]')
          let prismLeftSphereValue = getInputValue('#itg_properties_data input[name="properties[_Prism Sphere left]')
          let prismRightAxisValue = getInputValue('#itg_properties_data input[name="properties[_Prism Axis right]')
          let prismLeftAxisValue = getInputValue('#itg_properties_data input[name="properties[_Prism Axis left]')

          if (rightAddValue > 3 || leftAddValue > 3 || rightAddValue < -3 || leftAddValue < -3) {
              const msgToShow = document.querySelector('.product__info-wrapper .outside_range_header').innerHTML;
              showNotAvailabilityPopup(msgToShow);
              document.querySelector('.cstm_customize__product .prescription_product_overlay').classList.remove('prescription_product_overlay_active');
              return;
          }
          
          if (prismRightSphereValue > 3 || prismLeftSphereValue > 3 || prismRightSphereValue < -3 || prismLeftSphereValue < -3 
              || prismRightAxisValue > 3 || prismLeftAxisValue > 3 || prismRightAxisValue < -3 || prismLeftAxisValue < -3 
            ) {
              const msgToShow = document.querySelector('.product__info-wrapper .outside_range_header').innerHTML;
              showNotAvailabilityPopup(msgToShow);
              document.querySelector('.cstm_customize__product .prescription_product_overlay').classList.remove('prescription_product_overlay_active');
              return;
          }
        }

      });
    });
  }

  // Non Availability Popup *******************************
  function showNotAvailabilityPopup(msgToShow) {
    document.getElementById('DrawerSpinner').style.display = 'flex';
    document.querySelector('body.itg_main_product_temp').classList.add('overflow-hide');
    document.querySelector('.customize_product_drawer_wrapper').classList.add('customize_product_drawer_active', 'customize_prescription_popup', 'prescription_recommendation');

    const MainPopup = document.createElement('div');
    const PopupContent = document.createElement('div');
    const NoMatchedPopupContent = document.createElement('a');
    MainPopup.className = 'MainPopup';
    PopupContent.className = 'PopupContent';
    
    PopupContent.innerHTML = msgToShow;
    MainPopup.append(PopupContent);
    document.querySelector('.customize_product_drawer_content').innerHTML = MainPopup.outerHTML;
    document.getElementById('DrawerSpinner').style.display = 'none';
    document.querySelector('.customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons').classList.add('disabled-cart-button');
    return;
  }
  
  // ********************************* End Prescription Helping Functions and Variables *********************************


  
  // ********************************* Start Prescription Calculation *********************************
  let addRightPower = null;
  let addLeftPower = null;
  let addPower = null;
  let LensOptionType = '';
  let LensBrand = '';
  let frameBrandType = '';
  let frameSKU = ''; 
  let isLensTypeChanged = false;
  let isFrameSKUMatched = false;

  function PrescriptionCalculation () {
      document.querySelector('.cstm_customize__product .prescription_product_overlay').classList.add('prescription_product_overlay_active');
      document.getElementById('PrescriptionSpinner').style.display = 'flex';
      document.querySelector('.customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons').classList.add('disabled-cart-button');
    
      //----------------- Prescription Range calculation JS Start ---------------------
      let prescriptionOption = document.querySelector('.enter_prescription'); 
      if (prescriptionOption && prescriptionOption.classList.contains('product_option__value_active')) {
      
          const getInputValue = (selector) => {
              const input = document.querySelector(selector);
              return input ? input.value.trim() : "";
          };

          // getSelectedBrand 
          LensBrand = document.querySelector('.product_option_brand .lens_name_active')?.getAttribute('option-value').trim();
          let VisionType = document.querySelector('.vision_type_item.vision_type_active')?.getAttribute('option-value').trim();
      
          // Fetch raw values
          let sphereRightValueRaw    = getInputValue('#itg_properties_data input[name="properties[_right_sphere]"]');
          let sphereLeftValueRaw     = getInputValue('#itg_properties_data input[name="properties[_left_sphere]"]');
          let cylinderRightValueRaw  = getInputValue('#itg_properties_data input[name="properties[_right_cylinder]"]');
          let cylinderLeftValueRaw   = getInputValue('#itg_properties_data input[name="properties[_left_cylinder]"]');
          let axisRightValue         = parseFloat(getInputValue('#itg_properties_data input[name="properties[_right_axis]"]')) || 0;
          let axisLeftValue          = parseFloat(getInputValue('#itg_properties_data input[name="properties[_left_axis]"]')) || 0;

          // Calculate numeric values
          let sphereRightValue   = parseFloat(sphereRightValueRaw) || 0;
          let cylinderRightValue = parseFloat(cylinderRightValueRaw) || 0;
          let sphereLeftValue    = parseFloat(sphereLeftValueRaw) || 0;
          let cylinderLeftValue  = parseFloat(cylinderLeftValueRaw) || 0;
          let sumRight = 0;
          let sumLeft  = 0;

          if(!LensBrand.includes('Sunberryrx')) {
            let rightAddValue = getInputValue('#itg_properties_data input[name="properties[_right_add]"]')
            let leftAddValue = getInputValue('#itg_properties_data input[name="properties[_left_add]"]')
            let prismRightSphereValue = getInputValue('#itg_properties_data input[name="properties[_Prism Sphere right]')
            let prismLeftSphereValue = getInputValue('#itg_properties_data input[name="properties[_Prism Sphere left]')
            let prismRightAxisValue = getInputValue('#itg_properties_data input[name="properties[_Prism Axis right]')
            let prismLeftAxisValue = getInputValue('#itg_properties_data input[name="properties[_Prism Axis left]')

            if ( cylinderRightValue > 3 || cylinderLeftValue > 3 || cylinderRightValue < -3 || cylinderLeftValue < -3
                  || rightAddValue > 3 || leftAddValue > 3 || rightAddValue < -3 || leftAddValue < -3 
                  || prismRightSphereValue > 3 || prismLeftSphereValue > 3 || prismRightSphereValue < -3 || prismLeftSphereValue < -3 
                  || prismRightAxisValue > 3 || prismLeftAxisValue > 3 || prismRightAxisValue < -3 || prismLeftAxisValue < -3 
                ) {
                return;
            }
          }

          const CombinedRightObject = {
            valueType: 'RightObject',
            sphereValue: sphereRightValue,
            cylinderValue: cylinderRightValue
          }
          const CombinedLeftObject = {
            valueType: 'LeftObject', 
            sphereValue: sphereLeftValue,
            cylinderValue: cylinderLeftValue
          };
    
          sumRight = CalculateCombinedSpheres(CombinedRightObject);
          sumLeft = CalculateCombinedSpheres(CombinedLeftObject);
          let flippedCylinderRight = LensBrand.includes('Sunberryrx') ? (cylinderRightValue * -1) : cylinderRightValue ;
          let flippedCylinderLeft  = LensBrand.includes('Sunberryrx') ? (cylinderLeftValue * -1) : cylinderLeftValue;
          let newAxisRightValue = axisRightValue < 90 ? axisRightValue + 90 : axisRightValue - 90;
          let newAxisLeftValue  = axisLeftValue  < 90 ? axisLeftValue  + 90 : axisLeftValue  - 90;
      
          const setInputValue = (selector, value, label) => {
              const input = document.querySelector(selector);
              if (input) input.value = value;
          };
      
          // Set input values & log
          setInputValue('input.newsphere_value_right',sumRight);
          setInputValue('input.newsphere_value_left',sumLeft);
          setInputValue('input.newcylinder_value_right',flippedCylinderRight);
          setInputValue('input.newcylinder_value_left',flippedCylinderLeft);
          setInputValue('input.newaxis_value_right',newAxisRightValue);
          setInputValue('input.newaxis_value_left',newAxisLeftValue);

          // Get Lens Option type 
          let LensOptionTypeRaw = document.querySelector('li.product_option__value.all_brand_options.all_brand_active')?.getAttribute('option-color-type').trim();
          if(LensOptionTypeRaw){
            LensOptionType = LensOptionTypeRaw?.toLowerCase().includes('polarized') ? 'Polarized' : 'Clear';
          }
        
          frameBrandType = document.querySelector('.product__info-wrapper .main_product--title')?.getAttribute('data-product-title').trim();
          frameSKU = document.querySelector('.product__info-wrapper #ProductSKU')?.textContent.trim();
          if(document.querySelector('#itg_properties_data [name="properties[_right_add]"]')) {
            addRightPower = Number(document.querySelector('#itg_properties_data [name="properties[_right_add]"]')?.value.trim());
          }
          if(document.querySelector('#itg_properties_data [name="properties[_left_add]"]')) {
            addLeftPower = Number(document.querySelector('#itg_properties_data [name="properties[_left_add]"]')?.value.trim());
          }

          if(LensBrand.includes('Sunberryrx')) {
            if( addRightPower && ((Math.sign(sumRight) === 1) || (Math.sign(sumRight) === 0 )) ) {
              sumRight = sumRight + addRightPower;
            }
            if( addLeftPower && ((Math.sign(sumLeft) === 1) || (Math.sign(sumLeft) === 0)) ) {
              sumLeft = sumLeft + addLeftPower;
            }
          }
        
          // Store all values in NewPresValues object
          Object.assign(NewPresValues, {
              lensOptionType: LensOptionType,
              LensBrand:      LensBrand,
              VisionType:     VisionType, 
              frameBrandType: frameBrandType,
              frameSKU:       frameSKU,
              sphereRight:    sumRight,
              sphereLeft:     sumLeft,
              cylinderRight:  flippedCylinderRight,
              cylinderLeft:   flippedCylinderLeft,
              axisRight:      newAxisRightValue,
              axisLeft:       newAxisLeftValue,
              pdValue:        pdValue
          });

          console.log("NewPresValues Object -------->> ", NewPresValues);
      }
      
      document.querySelector('body.itg_main_product_temp').classList.add('DisableClick');
    
      //--------------------- Prescription Calculation matching from Databse Table ---------------------
      let URL = `https://sunberryrx.store/prescription-database/prescription_table_${LensBrand === 'Sunberryrx'? 'sunberry' : 'luxottica'}.php`;
      fetch(URL, {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(NewPresValues)
      })
      .then(res => res.json())
      .then(data => {
        
          document.querySelector('.cstm_customize__product .prescription_product_overlay').classList.remove('prescription_product_overlay_active');
          document.getElementById('PrescriptionSpinner').style.display = 'none';
          isLensTypeChanged = data.isPrescriptionMatched ? data.isLensTypeChanged : false;
        
          console.log("Prescription matched JSON data ---------->> ", data);

        
          // ************************************************ For Sunberrryrx lenses ************************************************
          if(LensBrand === 'Sunberryrx') {
              
              if(data.isPrescriptionMatched && data.matchedItem && data.matchedColumn  ) {
              
                isFrameSKUMatched = data.isFrameSKUMatched;
                
                //------------ to Show recommendation - When prescription available but in other Range ----------------
                
                if(data.isFrameSKUMatched) {
                    if(data.isLensTypeChanged || data.isSphereRangeIncreased) {
                      document.getElementById('DrawerSpinner').style.display = 'flex';
                      document.querySelector('body.itg_main_product_temp').classList.add('overflow-hide');
                      document.querySelector('.customize_product_drawer_wrapper').classList.add('customize_product_drawer_active', 'customize_prescription_popup', 'prescription_recommendation');
                
                      const MainPopup = document.createElement('div');
                      const PopupContent = document.createElement('div');
                      MainPopup.className = 'MainPopup';
                      PopupContent.className = 'PopupContent';
                      
                      const PDLensPoupContent = document.createElement('div');
                      PDLensPoupContent.className = 'PDLensPoupContent';
                      
                      let unavailabilityText = '';
                      let availableTypeAndValue = '';
                      let selectedPdNumber = NewPresValues.pdValue.includes('pd_one') ? Number(NewPresValues.pdValue.split('__')[1]) / 2 : Number(NewPresValues.pdValue.split('__')[1]) ;
                      let selectedPdRange = (selectedPdNumber >= 26 && selectedPdNumber <= 31.5) ? '27mm' : ((selectedPdNumber >= 32 && selectedPdNumber <= 36) ? '35mm' : '');
                      let selectedLensType = NewPresValues.lensOptionType;
                      let pdLowerRangeLimit = NewPresValues.pdValue.includes('pd_one') ? 63 : 31.5 ;
                      let pdHigherRangeLimit = NewPresValues.pdValue.includes('pd_one') ? 64 : 32 ;
                    
                      if (data.isLensTypeChanged) {
                        if(selectedLensType === 'Polarized'){
                          unavailabilityText = 'Polarized Lens type';
                          availableTypeAndValue = `Non-Polarized type lens`;
                        }
                        else if(selectedLensType === 'Clear'){
                          unavailabilityText = 'Clear Lens type';
                          availableTypeAndValue = `Polarized type lens`;
                        }
                      }
                      
                      PDLensPoupContent.textContent = `Sorry, this prescription is not available in ${unavailabilityText}. Please select a ${availableTypeAndValue} to match your prescription range in this frame.`
                      if(data.isPDRangeChanged || data.isLensTypeChanged) PopupContent.append(PDLensPoupContent);
                      if(data.isSphereRangeIncreased) PopupContent.append(document.querySelector('.ThinLensPoupContent').cloneNode(true));
                      
                      MainPopup.append(PopupContent);
                      document.querySelector('.customize_product_drawer_content').innerHTML = MainPopup.outerHTML;
                      document.getElementById('DrawerSpinner').style.display = 'none';                       
                      document.querySelector('#ThinLensNotSelected').style.display = 'none';
                      
                      if(data.isSphereRangeIncreased) {
                        document.querySelector('.customize_product_drawer_content .MainPopup').querySelector('.MainPopup #ChargesInput').setAttribute('id','ChargesInputNew');
                        document.querySelector('.customize_product_drawer_content .MainPopup').querySelector('.MainPopup label[for="ChargesInput"]').setAttribute('for','ChargesInputNew');
                        isSphereRangeChanged = data.isSphereRangeIncreased;
                        if (isThinLensSelected) {
                          const checkbox = document.querySelector('.customize_product_drawer_content .MainPopup #ChargesInputNew');
                          checkbox.checked = true;
                          const changeEvent = new Event('change', { bubbles: true });
                          checkbox.dispatchEvent(changeEvent);
                        }
                        else {
                          document.querySelector('#ThinLensNotSelected').style.display = 'block';
                        }
                        if(data.isPDRangeChanged || data.isLensTypeChanged) document.querySelector('.customize_product_drawer_content .PopupContentSeparator').style.display = 'block';
                      }
                      
                      if(data.isPDRangeChanged){
                        document.querySelectorAll('.vision_type_and_prescripiton_wrapper .active_puppilary_content .pd_distance_content_active .pd_required').forEach(select => select.value = '');
                      }
      
                      if(data.isLensTypeChanged){
                        document.querySelectorAll('.all_brand_options').forEach(allBrand_remove => allBrand_remove.classList.remove('all_brand_active'));
                        document.querySelectorAll('.product_option_values_grid.option_values_grid_three').forEach(el => el.classList.add('required_field'));
                      }
                    }
                  document.querySelector('body.itg_main_product_temp').classList.remove('DisableClick');
                }
                else {
                  
                //------------ to Show products recommendation - When no prescription matched available ----------------
                  
                  document.getElementById('DrawerSpinner').style.display = 'flex';
                  document.querySelector('body.itg_main_product_temp').classList.add('overflow-hide');
                  document.querySelector('.customize_product_drawer_wrapper').classList.add('customize_product_drawer_active', 'customize_prescription_popup', 'prescription_recommendation', 'prescription_recommended_products');
                  document.querySelector('.customize_product_drawer_content').innerHTML = '';
                  document.querySelector('#ThinLensNotSelected').style.display = 'none';
                  
                  const MainPopup = document.createElement('div');
                  const PopupContent = document.createElement('div');
                  const recommendedProductsWrapper = document.createElement('div');
                  MainPopup.className = 'MainPopup';
                  PopupContent.className = 'PopupContent';
                  recommendedProductsWrapper.className = 'RecommendedProductsWrapper';
                  const RecommendedHeader = document.querySelector('.product__info-wrapper .Product__Card_wrapper_header').innerHTML;
                  
                  const RecommendedButton = document.createElement('a');
                  RecommendedButton.className = 'RecommendedButton';
                  RecommendedButton.href = '/collections/prescription-sunglasses';
                  RecommendedButton.textContent = 'Shop All Prescription Sunglasses';
                  
                  let productsProcessed = 0;
                  const totalProducts = data.matchedItems.length;
  
                  data.matchedItems.forEach(product => {
                      const productHandle = product.products_handle;
                      fetch(`/products/${productHandle}`)
                      .then(response => response.text())
                      .then(html => {
                        const parser = new DOMParser(); 
                        const productCardContent = parser.parseFromString(html, 'text/html').querySelector('.product__info-wrapper .Product__Card_wrapper');
                        if (productCardContent) {
                            const productCard = document.createElement('div');
                            productCard.className = 'Product__Card';
                            productCard.innerHTML = productCardContent.innerHTML;
                            recommendedProductsWrapper.appendChild(productCard);
                        } else {
                            console.error("Product card content not found for:", productHandle);
                        }
  
                        productsProcessed++;
                        if (productsProcessed === totalProducts) {
                            PopupContent.innerHTML = RecommendedHeader;
                            PopupContent.appendChild(recommendedProductsWrapper);
                            PopupContent.appendChild(RecommendedButton);
                            MainPopup.appendChild(PopupContent);
                            document.querySelector('.customize_product_drawer_content').appendChild(MainPopup);
                            document.getElementById('DrawerSpinner').style.display = 'none';
                            document.querySelector('.customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons').classList.add('disabled-cart-button');
                            document.querySelector('body.itg_main_product_temp').classList.remove('DisableClick');
                        }
                        
                      })
                      .catch(error => {
                        console.error("Error fetching product: ", error);
                      });
                  })
                  
                }
                EnableAddToCart();
              }
              else {
                //------------When no prescription matched ----------------
                if(!data.isPrescriptionMatched) {
                  // const msgToShow = 'We’re sorry! The prescription you entered is currently outside the range we offer for sunglasses. Need help? Contact us at <a href="mailto:info@sunberryrx.com">info@sunberryrx.com</a>'
                  const msgToShow = document.querySelector('.product__info-wrapper .non_availability_header').innerHTML;
                  showNotAvailabilityPopup(msgToShow);
                  document.querySelector('body.itg_main_product_temp').classList.remove('DisableClick');
                  return;
                }
                document.querySelector('body.itg_main_product_temp').classList.remove('DisableClick');
                EnableAddToCart();
              }
            
            
          }
            
            
          // ************************************************ For Luxottica lenses ************************************************
          else {
            
              async function renderRecommendedProducts(data) {
                  const DrawerSpinner = document.getElementById('DrawerSpinner');
                  const body = document.querySelector('body.itg_main_product_temp');
                  const drawerWrapper = document.querySelector('.customize_product_drawer_wrapper');
                  const drawerContent = document.querySelector('.customize_product_drawer_content');
                
                  DrawerSpinner.style.display = 'flex';
                  body.classList.add('overflow-hide');
                  drawerWrapper.classList.add('customize_product_drawer_active', 'customize_prescription_popup', 'prescription_recommendation', 'prescription_recommended_products', 'prescription_recommended_products_for_luxottica');
                  drawerContent.innerHTML = '';
                  document.querySelector('#ThinLensNotSelected').style.display = 'none';
                
                  const MainPopup = document.createElement('div');
                  const PopupContent = document.createElement('div');
                  MainPopup.className = 'MainPopup';
                  PopupContent.className = 'PopupContent';
                  const RecommendedHeader = document.querySelector('.product__info-wrapper .non_availability_header').innerHTML;
                  PopupContent.innerHTML = RecommendedHeader;
                
                  const createProductCard = async (handle) => {
                    try {
                      const html = await fetch(`/products/${handle}`).then(res => res.text());
                      const parser = new DOMParser();
                      const cardContent = parser.parseFromString(html, 'text/html').querySelector('.product__info-wrapper .Product__Card_wrapper');
                      if (cardContent) {
                        const card = document.createElement('div');
                        card.className = 'Product__Card';
                        card.innerHTML = cardContent.innerHTML;
                        return card;
                      }
                    } catch (e) {
                      console.error("Failed to fetch product", handle, e);
                    }
                    return null;
                  };
                
                  // 1. matchedItemFromSunberry
                  if (data.matchedItemFromSunberry) {
                    const SuggestionHeading = document.querySelector('.product__info-wrapper .sunberryrx_lens_suggestion');
                    PopupContent?.appendChild(SuggestionHeading);
                    const SmallText = document.createElement('span');
                    SmallText.textContent = 'Happy Shopping!';
                    PopupContent?.appendChild(SmallText);
                    const wrapper = document.createElement('div');
                    wrapper.className = 'RecommendedProductsOne RecommendedProductsWrapper';
                    const card = await createProductCard(data.matchedItemFromSunberry.products_handle);
                    if (card) wrapper.appendChild(card);
                    PopupContent?.appendChild(wrapper);
                  }
                  
                  // 2. matchedItemsFromLuxottica
                  if (Array.isArray(data.matchedItemsFromLuxottica) && data.matchedItemsFromLuxottica.length !==0) {
                    const SuggestionHeadingContent = document.querySelector('.product__info-wrapper .luxottica_frames_suggestion').textContent.trim();
                    const SuggestionHeadingLuxottica = document.createElement('h3');
                    SuggestionHeadingLuxottica.textContent = SuggestionHeadingContent.replace('[BrandName]', LensBrand); 
                    SuggestionHeadingLuxottica.className = 'Sunberry_highlighted_line';
                    PopupContent?.appendChild(SuggestionHeadingLuxottica);
                    const wrapper = document.createElement('div');
                    wrapper.className = 'RecommendedProductsOne RecommendedProductsWrapper';
                    const promises = data.matchedItemsFromLuxottica.map(p => createProductCard(p.products_handle));
                    const cards = await Promise.all(promises);
                    cards.forEach(card => card && wrapper.appendChild(card));
                    PopupContent?.appendChild(wrapper);
                  }
                  
                  // 3. matchedItemsFromSunberrry
                  if (Array.isArray(data.matchedItemsFromSunberrry) && data.matchedItemsFromSunberrry.length !==0) {
                    const SuggestionHeading = document.querySelector('.product__info-wrapper .sunberryrx_frames_suggestion');
                    if(SuggestionHeading) {
                      PopupContent?.appendChild(SuggestionHeading);
                    }
                    const wrapper = document.createElement('div');
                    wrapper.className = 'RecommendedProductsOne RecommendedProductsWrapper';
                    const promises = data.matchedItemsFromSunberrry.map(p => createProductCard(p.products_handle));
                    const cards = await Promise.all(promises);
                    cards.forEach(card => card && wrapper.appendChild(card));
                    PopupContent?.appendChild(wrapper);
                  }
                    
                  // CTA Button
                  const RecommendedButton = document.createElement('a');
                  RecommendedButton.className = 'RecommendedButton';
                  RecommendedButton.href = '/collections/prescription-sunglasses';
                  RecommendedButton.textContent = 'Shop All Prescription Sunglasses';
                
                  PopupContent?.appendChild(RecommendedButton);
                  MainPopup.appendChild(PopupContent);
                  drawerContent.appendChild(MainPopup);
                
                  DrawerSpinner.style.display = 'none';
                  document.querySelector('.customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons').classList.add('disabled-cart-button');
                  body.classList.remove('DisableClick');
              }

              if(data && data.isPrescriptionMatched) {
                isFrameSKUMatched = data.isFrameSKUMatched;
                if(!data.isFrameSKUMatched && data.matchedItemsFromSunberrry.length > 0) renderRecommendedProducts(data);
                else document.querySelector('body.itg_main_product_temp').classList.remove('DisableClick');
              }
              else if(data.isPrescriptionMatched == false) {
                // const msgToShow = 'We’re sorry! The prescription you entered is currently outside the range we offer for sunglasses. Need help? Contact us at <a href="mailto:info@sunberryrx.com">info@sunberryrx.com</a>'
                const msgToShow = document.querySelector('.product__info-wrapper .non_availability_header').innerHTML;
                showNotAvailabilityPopup(msgToShow);
                document.querySelector('body.itg_main_product_temp').classList.remove('DisableClick');
                return;
              }
              else {
                if(data.error) {
                    document.querySelector('body.itg_main_product_temp').classList.remove('DisableClick');
                    
                  // setTimeout(()=> {
                  // },3000);
                }
              }
            
              EnableAddToCart();
          }
        
      })
      .catch(err => console.error('Fetch error:', err));
      
  }
  


  // Select PD Type  *****************************
  let is_pd_Two_selected = false;
  if(document.querySelectorAll('.pd_number_head').length > 0) {
    document.querySelectorAll('.pd_number_input_item').forEach(function(pdNumber) {
      pdNumber.addEventListener('click',function() {
        let isAllCylinderSelects = false;
        let isAllSphereSelects = false;
        if(document.querySelectorAll('.active_prescription_table .required_field[name*="_cylinder"]').length > 0 ) {
          isAllCylinderSelects = Array.from(document.querySelectorAll('.active_prescription_table .required_field[name*="_cylinder"]')).every(select => select.value.trim() !== '');
        }
        if(document.querySelectorAll('.active_prescription_table .required_field[name*="_sphere"]').length > 0 ) {
          isAllSphereSelects = Array.from(document.querySelectorAll('.active_prescription_table .required_field[name*="_sphere"]')).every(select => select.value.trim() !== '');
        }
        if(isAllCylinderSelects && isAllSphereSelects) {
            document.querySelectorAll('.pd_number_input_item').forEach(pdNumber_remove => pdNumber_remove.classList.remove('pd_number_input_item_active'));
            this.classList.add('pd_number_input_item_active');
            let pdTitle = this.getAttribute('pd-title');
            document.querySelectorAll('.pd_distance_content').forEach(pdDistance_remove => pdDistance_remove.classList.remove('pd_distance_content_active'));
            document.querySelectorAll('.pd_distance_content').forEach(function(checkDistance) {
                let pdContent = checkDistance.getAttribute('pd-content');
                if(pdContent === pdTitle){
                  checkDistance.classList.add('pd_distance_content_active');
                }
            });
            
            let enter_pd_content = this.closest('.pd_number_input_item_active')
            PresPDValues = getPdValues(enter_pd_content);
            
            if(!isAllAxisFilled) {
              alert('Please insert the Axis Range');
              document.querySelectorAll('.pd_number_input_item').forEach(pdNumber_remove => pdNumber_remove.classList.remove('pd_number_input_item_active'));
              document.querySelectorAll('.active_puppilary_content .pd_number_option_content_select_option_head .pd_distance_content').forEach(pdNumber_remove => pdNumber_remove.classList.remove('pd_distance_content_active'));
              return;
            }

            if(pdTitle !== 'no_pds'){
              PrescriptionCalculation();
            }
            if(pdTitle === 'pd_two'){
              is_pd_Two_selected = true;
            }
            if (pdTitle === 'no_pds'){
              pdValue = 'no_pds';
              PrescriptionCalculation();
            }
            
        }
        else {
            if(!isAllCylinderSelects && !isAllSphereSelects) alert('Please select Sphere and Cylinder value.');
            else if(!isAllCylinderSelects) alert('Please select a Cylinder value. If you do not have a Cylinder value, please select 0.00.'); 
            else if(!isAllSphereSelects) alert('Please select a Sphere value.');
            document.querySelectorAll('.pd_number_input_item').forEach(el => el.classList.remove('pd_number_input_item_active'))
            document.querySelectorAll('.pd_number_option_content_head .pd_distance_content').forEach(el => el.classList.remove('pd_distance_content_active'));
        }


        
      });
    });
  }


  // Select PD Value  *****************************
  if(document.querySelectorAll('.product-custom-option').length > 0) {
    document.querySelectorAll('.product-custom-option').forEach(function(enterPD) {
      enterPD.addEventListener('change',function() {
        let pdName = enterPD.getAttribute('name');
        const PDidentifier = enterPD.getAttribute('data-pd-identifier');
        if(enterPD.closest('.pd_distance_content_active[pd-content="pd_one"]')){
          document.querySelectorAll(`#itg_properties_data input[name*="${PDidentifier}"]`).forEach(rightEnter_remove => rightEnter_remove.remove());
        }
        else if (enterPD.closest('.pd_distance_content_active[pd-content="pd_two"]')){
          if(is_pd_Two_selected){
            document.querySelectorAll(`#itg_properties_data input[name*="${PDidentifier}"]`).forEach(rightEnter_remove => rightEnter_remove.remove());
            is_pd_Two_selected = false;
          }
          document.querySelectorAll(`#itg_properties_data input[name*="${pdName}"]`).forEach(rightEnter_remove => rightEnter_remove.remove());
        }
      
        if(enterPD.value){
          let pdval = enterPD.value;
          if(pdName == 'properties[_right_pd_dist__left_pd_dist]'){
            document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_left_pd_dist]" value="${pdval/2}">`);
            document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_right_pd_dist]" value="${pdval/2}">`);
            pdValue = `pd_one__${pdval}`;
          }
          else {
            document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="${pdName}" value="${pdval}">`);
            pdValue = `pd_two__${pdval}`;
          }
        }
      
        let enter_pd_content = enterPD.closest('.pd_distance_content_active')
        PresPDValues = getPdValues(enter_pd_content);
        if(!isAllAxisFilled)  {
          alert('Please insert the Axis Range');
          document.querySelectorAll('.pd_number_input_item').forEach(pdNumber_remove => pdNumber_remove.classList.remove('pd_number_input_item_active'));
          document.querySelectorAll('.active_puppilary_content .pd_number_option_content_select_option_head .pd_distance_content').forEach(pdNumber_remove => pdNumber_remove.classList.remove('pd_distance_content_active'));
          return;
        }
        PrescriptionCalculation();
      });
    });
  }

  // Calculate Combined Spheres *********************************
  function CalculateCombinedSpheres(CombinedObject) {
    const sphere = CombinedObject.sphereValue;
    const cylinder = CombinedObject.cylinderValue;
  
    if (CombinedObject.valueType === 'RightObject') {
      if (
        (sphere === 0 && cylinder > 0) || (sphere > 0 && cylinder === 0) ||
        (sphere > 0 && cylinder > 0) || (sphere < 0 && cylinder < 0)
      ) {
        return sphere + cylinder;
      } else {
        return sphere;
      }
    }
  
    if (CombinedObject.valueType === 'LeftObject') {
      if (
        (sphere === 0 && cylinder > 0) || (sphere > 0 && cylinder === 0) ||
        (sphere > 0 && cylinder > 0) || (sphere < 0 && cylinder < 0)
      ) {
        return sphere + cylinder;
      } else {
        return sphere;
      }
    }
  
    return null; 
  }


  // Calculate Combined Power *********************************
  function CalculateCombinedPower () {
    let CombinedRightSphere = 0;
    let CombinedLeftSphere = 0;
    let addRightPower = Number(document.querySelector('#itg_properties_data [name="properties[_right_add]"]')?.value.trim());
    let addLeftPower = Number(document.querySelector('#itg_properties_data [name="properties[_left_add]"]')?.value.trim());
    let RightSphere = Number(document.querySelector('#itg_properties_data [name="properties[_right_sphere]"]')?.value.trim());
    let LeftSphere = Number(document.querySelector('#itg_properties_data [name="properties[_left_sphere]"]')?.value.trim());
    let RightCylinder = Number(document.querySelector('#itg_properties_data [name="properties[_right_cylinder]"]')?.value.trim());
    let LeftCylinder = Number(document.querySelector('#itg_properties_data [name="properties[_left_cylinder]"]')?.value.trim());

    const CombinedRightObject = {
      valueType: 'RightObject',
      sphereValue: RightSphere,
      cylinderValue: RightCylinder
    }
    const CombinedLeftObject = {
      valueType: 'LeftObject', 
      sphereValue: LeftSphere,
      cylinderValue: LeftCylinder
    };

    CombinedRightSphere = CalculateCombinedSpheres(CombinedRightObject);
    CombinedLeftSphere = CalculateCombinedSpheres(CombinedLeftObject);

    // ----- Add addPower for progressive Lens -------
    if(addRightPower) {
      CombinedRightSphere = CombinedRightSphere + addRightPower;
    }
    if(addLeftPower) {
      CombinedLeftSphere = CombinedLeftSphere + addLeftPower;
    }

    document.querySelector('#itg_properties_data [name="properties[_Combined Right SPH]"]')?.remove();
    document.querySelector('#itg_properties_data [name="properties[_Combined Left SPH]"]')?.remove();
    document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_Combined Right SPH]" value="${CombinedRightSphere}">`);
    document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_Combined Left SPH]" value="${CombinedLeftSphere}">`);
  }
  
 
  // ********************************* End Prescription Calculation *********************************
  


  // *********************************  Start-form-submit  *********************************
  if(document.querySelectorAll('.itg_submit_btn').length > 0) {
    document.querySelector('.itg_submit_btn').addEventListener('click',function() {
      document.querySelector('.addLoader').classList.add('it_loading'); 

      let lensImage = '' ;
      let isReplacmentLens = false ;
      isReplacmentLens = localStorage.getItem('hideReplacementDataOptions') ;
      if(isReplacmentLens == 'true'){
        lensImage = document.querySelector(".product_option_brand_lens_content.produc_brand_option_active .product_option__value.all_brand_options.all_brand_active")?.getAttribute("data-lensimage") ;
        document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_replacment_lens_product]" value="${isReplacmentLens}">`);
        document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_replacment_lens_image]" value="${lensImage}">`);
      }
    
      const formData = new FormData();
      let proId = this.getAttribute('data-id');

      // ------------------- to save properties in localstorage -------------
      // Use the locked, legitimately-calculated price instead of the DOM attribute (DevTools-tamper stopgap).
      let proPrice = lockedPrice;
      // Part 1: authoritative verification. Recompute the price from the trusted store and
      // require it to match the locked price we are about to send. This blocks add-to-cart on
      // any inconsistency (e.g. DOM price tampering) instead of POSTing a wrong/zero price.
      // CAVEAT: client-side only; a direct POST to variant_combination.php still bypasses this.
      const verifyPrice = calPrice(); // recompute from trusted store (also refreshes display + lockedPrice)
      if (proPrice === null || proPrice === undefined) {
        proPrice = verifyPrice; // legitimate first-time fallback when no calc had run yet
      }
      if (parseFloat(proPrice) !== parseFloat(verifyPrice)) {
        document.querySelector('.addLoader').classList.remove('it_loading');
        alert('Something went wrong, please refresh and try again');
        return;
      }
      proPrice = verifyPrice; // send the freshly verified authoritative value
      let productTitle = document.querySelector(".product__title[data-product-title]").getAttribute("data-product-title")  ;
      let productImageSrc = document.querySelector(".product__media-item.grid__item.slider__slide.is-active .product__media img").getAttribute("src")  ;

      let productReplacementLensImage = document.querySelector(".collection_replacement_localdata .product__modal-opener .product__media.media img")?.getAttribute("src")  ;
    
      let getPageURL = location.href.split("products")[1];
      let productURL = `/products${getPageURL}`;


      formData.append('pro_id', proId);
      formData.append('price', proPrice);
      if(lensImage !== '') {
        formData.append('replacement_image', lensImage);
      }

      if(productImageSrc !== '') {
      //   formData.append('main_image', productImageSrc);
      }
    
      let selectedFrameSize = document.querySelector('[name="properties[Fit]"]')?.value.split(' ')[0];
      let selectedFrameColor = document.querySelector('[name="properties[Frame Color]"]') 
        ? document.querySelector('[name="properties[Frame Color]"]').value : 
        document.querySelector(`#itg_properties_data input[name="properties[Lens Option]"]`).value;
        

      formData.append('frame_size', selectedFrameSize);
      formData.append('frame_color', selectedFrameColor);
      // console.log('value ------------->', selectedFrameColor, selectedFrameSize);

    
    
      var xhr = new XMLHttpRequest();

      // xhr.open('POST', 'https://sunberryrx.store/storefront/variant.php', true);
      xhr.open('POST', 'https://sunberryrx.store/storefront/variant_combination.php', true);
      xhr.onload = function() {
        if (xhr.status === 200) {
          document.querySelector('.product-variant-id').value = xhr.responseText;

          let productVariantId =  xhr.responseText ;
          
          localStorage.setItem('recentVariantPrice',proPrice);
          localStorage.setItem('recentProductTitle',productTitle);
          localStorage.setItem('recentProductImage',productImageSrc);
          localStorage.setItem('recentProductURL',productURL);
          
          localStorage.setItem(productVariantId , proPrice );


          if(productReplacementLensImage != undefined )
            localStorage.setItem('recentProductReplacementLensImage',productReplacementLensImage);
          else
            localStorage.setItem('recentProductReplacementLensImage',"");
      
          setTimeout(function() {
            let AddtoCartIcon = document.querySelector('.itg_submit_form');
            AddtoCartIcon.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            }));
            document.querySelector('.addLoader').classList.remove('it_loading');
            
          }, 4500);
          
        }
      };
      xhr.onerror = function () {};
      xhr.send(formData);

    });
  }
  // *********************************  End-form-submit  *********************************



  // *********************************  Start Change Lens Size  *********************************
  function changeLensSize(infoIcon) {
    if(document.querySelector('.customize_product_drawer_wrapper .lens_width')) {
      document.querySelector('.customize_product_drawer_wrapper .lens_width').textContent = infoIcon.getAttribute('data-lens-width') + 'mm';
    }
    if(document.querySelector('.customize_product_drawer_wrapper .lens_height')) {
      document.querySelector('.customize_product_drawer_wrapper .lens_height').textContent = infoIcon.getAttribute('data-lens-height') + 'mm';
    }
    if(document.querySelector('.customize_product_drawer_wrapper .bridge_width')) {
      document.querySelector('.customize_product_drawer_wrapper .bridge_width').textContent = infoIcon.getAttribute('data-bridge-size') + 'mm';
    }
    if(document.querySelector('.customize_product_drawer_wrapper .temple_length')) {
      document.querySelector('.customize_product_drawer_wrapper .temple_length').textContent = infoIcon.getAttribute('data-temple-length') + 'mm';
    }
  }
  // *********************************  End Change Lens Size  *********************************

  

  // *********************************  Start - Info Icon Functionality  *********************************
  function addLensOptionTab(infoLabelValue) {
    uniqueLensOptions.forEach((name) => {
      const tabDiv = document.createElement('div');
      tabDiv.className = 'lens-tab-button'; 
      tabDiv.id = name.toLowerCase(); 
    });
    console.log(infoLabelValue)
    document.getElementById(infoLabelValue.trim()).click();
  }

  let infoIconAll = document.querySelectorAll('.customize_main_product_wrapper .info_icon');
  let customizeProductDrawer = document.querySelector('.customize_product_drawer_wrapper');
  let productDrawerContent = document.querySelector('.customize_product_drawer_content');

  infoIconAll.forEach(function(infoIcon) {
    infoIcon.addEventListener('click',function() {
      document.getElementById('DrawerSpinner').style.display = 'flex';
      customizeProductDrawer.classList.add('customize_product_drawer_active');
      document.querySelector('body.itg_main_product_temp').classList.add('overflow-hide');

      if(this.closest('.enter_prescription_details_head')){
        customizeProductDrawer.classList.add('customize_prescription_popup');
        const MainPopup = document.createElement('div');
        MainPopup.className = 'MainPopup';
        
        const PopupHeading = document.createElement('h2');
        PopupHeading.className = 'PopupHeading';
        PopupHeading.textContent = 'Learn How To Enter Your Prescription';
        
        const PopupContent = document.createElement('div');
        PopupContent.className = 'PopupContent';
        
        const PopupImgContent = document.createElement('img');
        PopupImgContent.src = document.getElementById('SizeGuideChart').getAttribute('src');
        PopupContent.append(PopupImgContent)
        MainPopup.append(PopupHeading);
        MainPopup.append(PopupContent);
        
        productDrawerContent.innerHTML = MainPopup.outerHTML;
        document.getElementById('DrawerSpinner').style.display = 'none';
      }
      else{
        let infoLabelValue = this.getAttribute('info-label');
        
        const isLensOptionsPresent = uniqueLensOptions?.some(
          el => el.trim().toLowerCase() === infoLabelValue.trim().toLowerCase()
        );
        
        
        let infoURL = '';
        if(infoIcon.classList.contains('standard_info_icon')){
          infoURL = '/pages/lens-options-polarized-mirrored-standard-gradient-prizm';
        }
        else{
          infoURL = isLensOptionsPresent ? `/pages/lens-options-polarized-mirrored-standard-gradient-prizm` : `/pages/${infoLabelValue}`;
        }
        
        fetch(infoURL)
          .then((response)=>{
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
          })
          .then((data)=>{
            const parser = new DOMParser()
            let responseHTML = parser.parseFromString(data,'text/html');
            let responseTragetID = responseHTML.querySelector('#MainContent')
            if(responseTragetID){
              productDrawerContent.innerHTML = responseTragetID.outerHTML;
              // console.log(responseTragetID)
              if(infoIcon.closest('.product_option_brand_lens')){ addLensOptionTab(infoLabelValue); }
              changeLensSize (infoIcon);
              document.getElementById('DrawerSpinner').style.display = 'none';
              
            }
          })
          .catch((error)=>{
            console.log(error);
            console.log('No page found')
          })
      }
      
       
    });
  });
  // *********************************  End - Info Icon Functionality  *********************************



  // *********************************  Start - Close Popup Functionality  *********************************
  function closePopupMain () {
    customizeProductDrawer.classList.remove('customize_product_drawer_active', 'customize_prescription_popup', 'prescription_recommendation', 'prescription_recommended_products', 'prescription_recommended_products_for_luxottica');
    document.querySelector('.customize_product_drawer_wrapper .customize_product_drawer_inner').classList.remove('customize_product_drawer_inner_Additonal');
    document.querySelector('body.itg_main_product_temp').classList.remove('overflow-hide');
    document.querySelector('.customize_product_drawer_content').innerHTML = '';
    if(document.querySelector('.product_option_values_head.product_option_brand_lens_active')) {
      const optionLabel = document.querySelector('.produc_brand_option_active .product_option_label_head .product_option_label')
      if(isLensTypeChanged){
        document.querySelector('.product_option_values_head.product_option_brand_lens_active').scrollIntoView({behavior: 'smooth', block: 'center'});
        if(optionLabel) { optionLabel.style.color = 'red'; }
      }
      else {
        if(optionLabel) { optionLabel.removeAttribute('style'); }
      }
    }
  }
  document.addEventListener('click', function(event) {
    if ( event.target.closest('#ProceedForThinLens') || event.target.closest('#DrawerClose') || event.target.closest('.customize_product_drawer_overlay') ) {
      closePopupMain();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && !document.querySelector('body.itg_main_product_temp').classList.contains('DisableClick')) {
      closePopupMain();
    }
  });
  // *********************************  End - Close Popup Functionality  *********************************

  
  
  // *********************************  Start - Tab clicked js  *********************************
  document.addEventListener('click',function (event) {
    const tab = event.target.closest('.lens-tab-button');
    if(tab){
      document.querySelectorAll('.lens-tab-button').forEach(element => element.classList.remove('active-tab'));
      tab.classList.add('active-tab');
      document.querySelectorAll('.Lens-comparison-tab').forEach(element => element.classList.remove('active-tab-content'));
      document.querySelector(`.Lens-comparison-tab[data-lens-option=${tab.id}]`).classList.add('active-tab-content');
    }
  })
  // *********************************  End - Tab clicked js  *********************************
 


  // *********************************  Start - Prism Correction clicked js  *********************************

  document.getElementById('PrismCorrection').addEventListener('change',function (event) {
    const PrismCorrectionWrapper = document.querySelector('.enter_prescription_prism_correction .enter_prescription_details_head');
    const isAllPrismSelectsFilled = Array.from(document.querySelectorAll('.enter_prescription_prism_correction .sphere_enter')).every(select => select.value.trim() !== '')
    if(event.target.checked) {
      PrismCorrectionWrapper.classList.add('prism_correction_active');
      if(isFrameSKUMatched) EnableAddToCart();
      else if(isAllPrismSelectsFilled) PrescriptionCalculation();
    }
    else {
      PrismCorrectionWrapper.classList.remove('prism_correction_active');
      if(isFrameSKUMatched) EnableAddToCart();
      else if(isAllPrismSelectsFilled) PrescriptionCalculation();
    } 
  })
  // *********************************  End - Prism Correction clicked js  *********************************
  


  // *********************************  Start - Popup Checkbox Click Functionality  *********************************
  document.addEventListener('click', function (event) {
    if (event.target.id === 'ChargesInputNew' && event.target.type === 'checkbox') {
      if (event.target.checked) {
        document.querySelector('.thin_lens_price').innerHTML = ''
          const li = document.querySelector('.thin_lens_price');
          
          const span1 = document.createElement('span');
          span1.className = 'richtext_regular_big itg_regular_big';
          span1.textContent = '|'; 
          li.appendChild(span1); 
          
          const span2 = document.createElement('span');
          span2.className = 'priceing_braekdown_label richtext_regular_big';
          span2.textContent = 'Thin Lens'; 
          li.appendChild(span2); 
  
          let main_symbol = document.querySelector('.itg_main_product_temp').getAttribute('data-sym');
          let thinlensPrice = document.querySelector('.ProceedForThinLensWr').getAttribute('data-additionalprice');    
          let currthinlensPrice = document.querySelector('.ProceedForThinLensWr').getAttribute('data-curr-additionalprice');        
          
          const span3 = document.createElement('span');
          span3.textContent = `+${main_symbol}${currthinlensPrice}` ; 
          span3.setAttribute('data-thin-lens-price',thinlensPrice) ;
          span3.setAttribute('data-currthin-lens-price',currthinlensPrice) ;
          setTrustedPrice(span3, currthinlensPrice); // mirror legit price into trusted store (Part 1)
          li.appendChild(span3);
          
          if(document.querySelector('.price_breakdown_grid')){
            document.querySelector('.price_breakdown_grid').append(li);
            isThinLensSelected = true;
            document.querySelector('#ThinLensNotSelected').style.display = 'none';
            EnableAddToCart();
          }
      }
      else{
        document.querySelector('#ThinLensNotSelected').style.display = 'block';
        document.querySelector('.thin_lens_price').innerHTML = '';
        isThinLensSelected = false;
        EnableAddToCart();
      }
      
      calPrice();
    }
   
  });
  // *********************************  End - Popup Checkbox Click Functionality  *********************************



  // *********************************  Start - Thin Lens Not Selected Click  *********************************
  document.querySelector('#ThinLensNotSelected').onclick = function() {
    PrescriptionCalculation();
  }
  // *********************************  End - Thin Lens Not Selected Click  *********************************
  


  // *********************************  Start - Made Media Sticky On Mobile  *********************************
  const mediaQuery = window.matchMedia("(max-width: 600px)");
  
  function handleStickyBehavior() {
    if (!mediaQuery.matches) return; // Exit if screen width > 600px

    const slidermobile = document.querySelector('.customize_main_product_wrapper [id^="GalleryViewer-template"]');
    const slidermobileThumbnail = document.querySelector('.customize_main_product_wrapper [id^="GalleryThumbnails-template"]');
    const mediaWrapper = slidermobile.closest('.product__media-wrapper');
    const slidermobilecontent = document.querySelector('.customize_main_product_wrapper .product__info-wrapper.grid__item');

    if (!slidermobile || !slidermobileThumbnail || !mediaWrapper || !slidermobilecontent) return;

    let sliderTopOffset = mediaWrapper.offsetTop;

    function updateSticky() {
        let scrollPosition = window.scrollY || window.pageYOffset;

        if (scrollPosition <= 5) {
            slidermobileThumbnail.classList.remove("hidden");
            mediaWrapper.classList.remove("sticky");
        } else if (scrollPosition >= sliderTopOffset) {
            mediaWrapper.classList.add("sticky");
            requestAnimationFrame(() => {
                slidermobileThumbnail.classList.add("hidden");
            });
        } else {
            mediaWrapper.classList.remove("sticky");
            requestAnimationFrame(() => {
                slidermobileThumbnail.classList.remove("hidden");
            });
        }
    }

    window.addEventListener("scroll", updateSticky, { passive: true });

    // **Using MutationObserver to watch for changes in 'sticky' class**
    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.attributeName === "class") {
                if (mediaWrapper.classList.contains("sticky")) {
                    slidermobilecontent.classList.add("sticky_content");
                } else {
                    slidermobilecontent.classList.remove("sticky_content");
                }
            }
        }
    });

    observer.observe(mediaWrapper, { attributes: true, attributeFilter: ["class"] });
  }
  
  handleStickyBehavior();
  mediaQuery.addEventListener("change", handleStickyBehavior);
  // *********************************  End - Made Media Sticky On Mobile  *********************************



  let container = document.querySelector("ul.product_option_values_grid.option_values_grid_two");
  if (container) {
    let listItems = container.querySelectorAll("li");
    let element = document.querySelector(".product_option_values_head.product_option_brand span.product_option_selected_value");
  
    if (listItems.length < 2 && listItems.length > 0) { 
        listItems[0].click();
    } else if (listItems.length >= 2) { 
        listItems.forEach(li => li.classList.remove("lens_name_active"));  
        element.textContent = ""; 
    }
  }

  document.querySelectorAll('.lens_types_brand_wrapper').forEach(el => {
    if(el.querySelectorAll('.product_option__value').length == 0){
      el.style.setProperty("display",'none',"important");
    }
  })

  document.querySelectorAll('.customize_main_product_wrapper ul.option_values_grid_three').forEach(el => {
    if(el.querySelectorAll('.lens_types_brand_wrapper').length == 2){
      el.classList.add('option_values_grid_two_only');
    }
  })



  // *********************************  Start - OC/SEG Height Calculation:   *********************************
  const Lensheight = Number(document.querySelector('.produc_details_wrapper .lens_height_info td:last-child').textContent.trim().replace('mm',''));
  const OC_OG_Height = (Lensheight/2) + 3;
  document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_OC/SEG Height]" value="${OC_OG_Height}">`);

  if(document.querySelector('.product_option__value.product_option_fit_data.fit_option_active')) {
    document.querySelector('.product_option__value.product_option_fit_data.fit_option_active').closest('.product_option_values_head').classList.remove('option_required_before_prescription')
  }

  if(document.querySelector('.product_option__value.product_option_frame_color_data.frame_color_active')) {
    document.querySelector('.product_option__value.product_option_frame_color_data.frame_color_active').closest('.product_option_values_head').classList.remove('option_required_before_prescription')
  }

  if(document.querySelector('.product_option__value.product_option_brand_data.lens_name_active')) {
    document.querySelector('.product_option__value.product_option_brand_data.lens_name_active').closest('.product_option_values_head').classList.remove('option_required_before_prescription')
  }

  if(document.querySelector('body.collection_replacement_localdata')) {
    if(document.querySelector('.product_option__value.product_option_fit_data')) {
      document.querySelector('.product_option__value.product_option_fit_data').closest('.product_option_values_head').classList.remove('option_required_before_prescription')
    }
  
    if(document.querySelector('.product_option__value.product_option_frame_color_data')) {
      document.querySelector('.product_option__value.product_option_frame_color_data').closest('.product_option_values_head').classList.remove('option_required_before_prescription')
    }
  }
  // *********************************  End - OC/SEG Height Calculation:   *********************************

    
  // *********************************  Start - Show Replacement Progressive Lens Price on Load   *********************************
  if(document.querySelector('body').classList.contains('replacement_localdata')) {
    if(document.querySelector('.vision_type_and_prescripiton_wrapper #ReplacementLensProgressivePrice')) {
      const brandProgressivePrice = Number(document.querySelector('.vision_type_and_prescripiton_wrapper #ReplacementLensProgressivePrice').textContent) / 100;
      const brandProgressivePriceCurrency = document.querySelector(`.vision_type_and_prescripiton_wrapper #ProgressiveLensPrice`).getAttribute('data-price-currency');
      document.querySelector('.vision_type_item #ProgressiveLensPrice').textContent = `+ ${brandProgressivePriceCurrency+brandProgressivePrice}`
    }
  }
  // *********************************  End - Show Replacement Progressive Lens Price on Load   *********************************

      
  // *********************************  Start - Show 1.67 range Additional Price on Load   *********************************
  let additionalPriceAttr = 'data-regular-additional-price';
  let additionalLabelPriceAttr = 'data-label-regular-additional-price';
  if(document.querySelector('body').classList.contains('replacement_localdata')) {
    additionalPriceAttr = 'data-re-additional-price';
    additionalLabelPriceAttr = 'data-label-re-additional-price';
    
    const ReplacementAdditionalProceedWr = document.querySelector('.vision_type_and_prescripiton_wrapper .ProceedForThinLensWr');
    if(ReplacementAdditionalProceedWr) {
      ReplacementAdditionalProceedWr.setAttribute('data-additionalprice',ReplacementAdditionalProceedWr.getAttribute('data-re-additionalprice').trim());
      ReplacementAdditionalProceedWr.setAttribute('data-curr-additionalprice',ReplacementAdditionalProceedWr.getAttribute('data-re-curr-additionalprice').trim());
    }
  }
    
  const ReplacementAdditionalPriceElement = document.querySelector(`.vision_type_and_prescripiton_wrapper .additionalCharges[${additionalPriceAttr}]`);
  if(ReplacementAdditionalPriceElement) ReplacementAdditionalPriceElement.querySelector('strong').textContent = ReplacementAdditionalPriceElement.getAttribute(`${additionalPriceAttr}`).trim();

  const ReplacementAdditionalPriceLabel = document.querySelector(`.vision_type_and_prescripiton_wrapper [${additionalLabelPriceAttr}]`);
  if(ReplacementAdditionalPriceLabel) ReplacementAdditionalPriceLabel.querySelector('strong').textContent = ReplacementAdditionalPriceLabel.getAttribute(`${additionalLabelPriceAttr}`).trim();

  // *********************************  End - Show 1.67 range Additional Price on Load   *********************************



  // ********************************* Start - Show Replacement Lens Option Price on Load   *********************************
  const AllLensOptions = document.querySelectorAll('.product_option_brand_lens .product_option_brand_lens_content .all_brand_options');
  if(AllLensOptions && AllLensOptions.length > 0) {
    AllLensOptions.forEach((lensOption, index) => {
      if(document.querySelector('body').classList.contains('replacement_localdata')) {
          if(lensOption.getAttribute('data-re-currlensprice')) { lensOption.setAttribute('data-currlensprice', lensOption.getAttribute('data-re-currlensprice')); setTrustedPrice(lensOption, lensOption.getAttribute('data-re-currlensprice')); } // mirror legit price into trusted store (Part 1)
          if(lensOption.getAttribute('data-re-lenspricepro')) lensOption.setAttribute('data-lenspricepro', lensOption.getAttribute('data-re-lenspricepro'));
          if(lensOption.getAttribute('data-re-lensprice')) lensOption.setAttribute('data-lensprice', lensOption.getAttribute('data-re-lensprice'));
          if(lensOption.getAttribute('data-re-lensefirstprice')) lensOption.setAttribute('data-lensefirstprice', lensOption.getAttribute('data-re-lensefirstprice'));

          const Re_LensPriceShow = lensOption.querySelector('.option_brand_price > span:first-child').getAttribute('data-re-price-show');
          if(Re_LensPriceShow) lensOption.querySelector('.option_brand_price > span:first-child').textContent = Re_LensPriceShow;
        
          const Re_LensSalePriceShow = lensOption.querySelector('.option_brand_price > span:last-child').getAttribute('data-re-sale-price-show');
          if(Re_LensSalePriceShow) {
            lensOption.querySelector('.option_brand_price > span:last-child').textContent = Re_LensSalePriceShow;
            lensOption.querySelector('.option_brand_price').classList.add('sale_price_available');
          }
          else {
            lensOption.querySelector('.option_brand_price > span:last-child').textContent = '';
            lensOption.querySelector('.option_brand_price').classList.remove('sale_price_available');
          }
      }

      
      // -------------------  Show Lowest Price of Lens Options near Brand Name on Load   ------------------------
      if((AllLensOptions.length -1) === index) {
        const BrandLensOptionsWr = document.querySelectorAll('.product_option_brand_lens .product_option_brand_lens_content');
        if(BrandLensOptionsWr && BrandLensOptionsWr.length > 0) {
          BrandLensOptionsWr.forEach(LensOptionsWr => {
            const AllBrandOptions = LensOptionsWr.querySelectorAll('.all_brand_options');
            if(AllBrandOptions.length > 0) {
                const LensWrBrandName = LensOptionsWr.getAttribute('brand-name').trim();
                const OptionRespectiveBrand = document.querySelector(`.product_option_brand .product_option_brand_data[data-valuematch=${LensWrBrandName}]`);
                let LowestLensPrice = null;
                AllBrandOptions.forEach((LensOption, index) => {
                    const LensPrice = parseFloat(LensOption.getAttribute('data-currlensprice'));
                    if((LowestLensPrice === null) || (LowestLensPrice > LensPrice)) {
                      LowestLensPrice = LensPrice;
                    }
                    if(index === AllBrandOptions.length - 1 ) {
                      let BrandName;
                      if(OptionRespectiveBrand) {
                        OptionRespectiveBrand.querySelector('.option_brand_price').textContent = LowestLensPrice;
                        BrandName = OptionRespectiveBrand.getAttribute('option-value').trim();
                      }
                      if(document.querySelector(`.sunberryOakley--grid .block--${BrandName} .sunbOak-brand--list-price .PriceText`)) {
                        document.querySelector(`.sunberryOakley--grid .block--${BrandName} .sunbOak-brand--list-price .PriceText`).textContent = `From $${LowestLensPrice}`;
                      }
                    }
                })
            }
          })
        }
      }
      // ------------------- end ==> Show Lowest Price of Lens Options near Brand Name on Load   ------------------------
      
    })
  }
  // ********************************* End - Show Replacement Lens Option Price on Load   *********************************


  
  // ********************************* Start - Lower priced lens option order   *********************************
  let all_brand_lens_options_container = document.querySelectorAll(".product_option_values_grid .lens_types_brand_wrapper");
  all_brand_lens_options_container.forEach(container => {
    let valueElements = Array.from(container.querySelectorAll(".product_option__value"));
    let elementsWithPrice = valueElements
      .map(el => {
        let price = parseFloat(el.getAttribute('data-lensprice')) || 0;
        return { el, price };
      });

    elementsWithPrice.sort((a, b) => a.price - b.price);

    elementsWithPrice.forEach((item, index) => {
      const orderIndex = index + 1; 
      item.el.setAttribute('data-order-style', orderIndex);
      item.el.style.order = orderIndex;
    });
  });
  // ********************************* End - Lower priced lens option order   *********************************


  // -------------------  Remove    ------------------------

  if(document.querySelector('body').classList.contains('replacement_localdata')) {
    if(document.querySelector('[name="properties[Frame Material]"]')) document.querySelector('[name="properties[Frame Material]"]').remove(); 
    if(document.querySelector('[name="properties[Frame Color]"]')) document.querySelector('[name="properties[Frame Color]"]').remove(); 
    if(document.querySelector('[name="properties[Fit]"]')) document.querySelector('[name="properties[Fit]"]').remove(); 
    if(document.querySelector('[name="properties[_frame_size]"]')) document.querySelector('[name="properties[_frame_size]"]').remove(); 
  }
    
     
  // ********************************* Start - Matching selected variant using Variant Option Select  *********************************

  function matchSelectedVariant(selectedFrameSizeOption, selectedFrameColorOption) {

    let frameSize = null;
    let frameColor = null;

    if (selectedFrameSizeOption || selectedFrameColorOption) {
      frameSize = selectedFrameSizeOption?.getAttribute('option-value').split('_')[0];
      frameColor = selectedFrameColorOption?.getAttribute('option-value');
    }

    const urlTemp = new URL(window.location.href);
    const urlParamsTemp = new URLSearchParams(urlTemp.search);
    const tempVariantInUrl = urlParamsTemp.get('variant');
    const hasVariantParam = !!tempVariantInUrl;

    function updateVariantUrl(variantId) {
      if (!variantId) return;

      urlParamsTemp.set('variant', variantId);
      urlTemp.search = urlParamsTemp.toString();

      window.history.replaceState({}, '', urlTemp.toString());
    }


    if(document.querySelector('body.collection_replacement_localdata')) {
      SelectedVariantAvailable = true;

      let frameSizeForLens = frameSize.toLowerCase().trim() ;
      let matchedOptionLens ;
      const variantOptionsForLens = document.querySelectorAll('.customize_main_product_wrapper #ProductVariantSelectOptions select option');
      variantOptionsForLens.forEach(option => {
        const optionLensLabel = option.getAttribute("data-option-1").toLowerCase().trim() ;
        if (optionLensLabel === frameSizeForLens) {
          matchedOptionLens = option.getAttribute('value');

          // -------  Automatically Select Standard Lens Option  -----------------------------------
          // setTimeout(()=> { makeStandardLensOptionActive() }, 600);
          
          setTimeout(()=> { 
            if(enableStandardOptionActive) {
              makeStandardLensOptionActive() 
              enableStandardOptionActive = false;
            }
          }, 600);

          return ;
        }
      });
      updateVariantUrl(matchedOptionLens) ;
    }

    
    if(document.querySelector('body.nonreplacement_localdata')) {
      // -------  Automatically Select Standard Lens Option  -----------------------------------
      // setTimeout(()=> { makeStandardLensOptionActive() },600);

      if(enableStandardOptionActive === false && !frameColor) {
        document.querySelector('.product_option_frame_color_data').click();
      }
      
      setTimeout(()=> { 
        if(enableStandardOptionActive) {
          makeStandardLensOptionActive() 
          enableStandardOptionActive = false;
        }
      }, 600);
      
      if(document.querySelector('.customize_product_price_content')) document.querySelector('.customize_product_price_content').classList.add('show__price');
      if (frameSize == null || frameColor == null) {
        document.querySelector(".customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons").classList.add("disabled-cart-button");
        return null;
      }
    }

    const size = String(frameSize).trim();
    const color = String(frameColor).trim();

    if(document.querySelector('body.nonreplacement_localdata')) {
      if (size === "" || color === "") {
        document.querySelector(".customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons").classList.add("disabled-cart-button");
        return null;
      }
    }

    const searchString = `${size.toLowerCase()}/${color.toLowerCase()}`;
    const variantOptions = document.querySelectorAll('.customize_main_product_wrapper #ProductVariantSelectOptions select option');
    let matchedOption = null;

    document.querySelectorAll('li.product_option__value').forEach(el => el.classList.remove('disable-unavailable-option'));

    variantOptions.forEach(option => {
      const optionText = option.textContent.toLowerCase().replace(/\s*\/\s*/g, '/').replace(/\s+/g, ' ').trim();
      if (optionText === searchString) {
        matchedOption = option;
      }
      
      if (selectedFrameSizeOption.classList.contains('fit_option_active') && optionText.includes(size.toLowerCase()) && Number(option.dataset.qty) === 0 ) {
        let colorRawValue = option.textContent.split('/')[1].trim();
        if(document.querySelector(`li.product_option_frame_color_data[option-value="${colorRawValue}"]`)) {
          document.querySelector(`li.product_option_frame_color_data[option-value="${colorRawValue}"]`).classList.add('disable-unavailable-option');
          document.querySelector(`li.product_option_frame_color_data[option-value="${colorRawValue}"]`).classList.remove('frame_color_active');
        }
      }

    });

    
    if (matchedOption) {

      let MatchedvariantID = matchedOption.value;
      const qty = parseInt(matchedOption.getAttribute("data-qty") || "0", 10);
  
      // console.log(baseUrl , "baseurl") ;

      if (qty > 0) {
        document.querySelectorAll(`#itg_properties_data input[name="properties[_inventory_variant_id]"]`).forEach(input => input.remove());
        // document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_inventory_variant_id]" value="${MatchedvariantID}">`);
      
        document.querySelector("#itg_properties_data").insertAdjacentHTML("beforeend",`<input type="hidden" name="properties[_inventory_variant_id]" value="${MatchedvariantID}">`);
        document.querySelector(".customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons").classList.remove("disabled-cart-button");

        // console.log(MatchedvariantID  , "matched variant id") ;

        SelectedVariantAvailable = true;
        EnableAddToCart();
      }
      else {
        SelectedVariantAvailable = false;

        document.querySelector(".customize_main_product_wrapper .product .product__info-wrapper .product-form__buttons").classList.add("disabled-cart-button");
      }

      updateVariantUrl(MatchedvariantID) ;

    
      
    }


  }

  // ********************************* End - Matching selected variant using Variant Option Select  *********************************









  

  // -------------------------- end ==>  DOMContentLoaded   ------------------------------
});


 













